<!-- 联盟代发单编辑 -->
<template>
    <div class="saleorder-v3" v-loading="searchApParams._visible" element-loading-spinner="none">
        <div class="bread-nav" v-if="type == 3 || type == 1">
            <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
        </div>
        <div class="bread-nav" v-else>
            <el-button size="small" icon="el-icon-back" class="search-btn btn-primary" @click="goback()"></el-button>
            <el-button size="small" class="search-btn btn-primary" v-if="!dataReadonly" @click="showSearch()" tabindex="-1">搜索联盟配件(F2)</el-button>
            <el-button size="small" class="search-btn btn-primary" @click="showAPMsgDialog()" tabindex="-1">查看配件信息(F3)</el-button>
            <el-button size="small" class="search-btn btn-primary" @click.stop="submitForm('0')" :disabled="saving" v-if="type == 0 || type == 2">保存代发单(F11)</el-button>
            <el-button size="small" class="search-btn btn-primary" @click.stop="submitForm('1')" :disabled="saving" v-if="type == 0 || type == 2">提交代发单(F12)</el-button>
        </div>
        <!--   form     -->
        <div :class="showOrderMsg ? 'section-title' : 'section-title section-magin'" v-if="type != 3">
            <div>
                <span>订单信息</span>&nbsp;&nbsp;&nbsp;&nbsp;
                <span v-if="!showOrderMsg && submitData.EntpCusName">客户：{{ submitData.EntpCusName }}</span>
                <span style="margin-left: 10px; font-weight: 500">
                    【 销售总数：{{ allNum }} &nbsp;&nbsp; 销售总额：{{ allMoney }}
                    】
                </span>
            </div>
            <div class="img-e-op" @click="showMsg" v-show="!showOrderMsg">
                <img src="../../../assets/images/down-e.png" />
            </div>
            <div class="img-e-op" @click="hideMsg" v-show="showOrderMsg">
                <img src="../../../assets/images/up-e.png" />
            </div>
        </div>
        <div class="order-infoes" v-show="showOrderMsg">
            <el-form :model="submitData" ref="formMsg" label-width="90px" style="width: 100%; padding-right: 10px; padding-left: 10px" :rules="rules">
                <el-row :gutter="20">
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="选择客户" prop="EntpCusId">
                                <el-input v-if="type == 4" disabled size="small" v-model.trim="submitData.EntpCusName"> </el-input>
                                <el-select
                                    style="width: 100%"
                                    size="small"
                                    v-else
                                    :disabled="dataReadonly"
                                    v-model="submitData.EntpCusId"
                                    filterable
                                    clearable
                                    remote
                                    reserve-keyword
                                    :remote-method="searchCustomer"
                                    v-select-scroll-more="searchCustomLoad"
                                    @change="customerChange($event)"
                                    @visible-change="customerVisibleChange($event)"
                                    placeholder="输入客户名称/电话"
                                >
                                    <el-option
                                        v-for="optionItem in customerList"
                                        :key="optionItem.EntpCusId"
                                        :data-msg="optionItem"
                                        :label="optionItem.EntpCusName"
                                        :value="optionItem.EntpCusId"
                                    >
                                        <span style="float: left">{{ optionItem.EntpCusName }}</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px">{{ optionItem.CallNum }}</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="业务员" prop="SId">
                                <el-select
                                    v-model="submitData.SId"
                                    :disabled="dataReadonly"
                                    filterable
                                    clearable
                                    placeholder="请选择"
                                    @change="sIdChange($event)"
                                    @visible-change="siVisibleChange($event)"
                                    style="width: 100%"
                                    size="small"
                                >
                                    <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="联系电话" prop="PhoneNum">
                                <el-input :disabled="dataReadonly" v-model.trim="submitData.PhoneNum" size="small"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="发货方式" prop="ShipType">
                                <el-select v-model="submitData.ShipType" :disabled="dataReadonly" placeholder="请选择" style="width: 100%" size="small">
                                    <el-option v-for="item in DeliveryMethodList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            <el-form-item label="运输费用" prop="ShipAmount">
                                <el-input min="0" type="number" step="0.01" :disabled="dataReadonly" v-model.trim="submitData.ShipAmount" size="small"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="支付方式" prop="PayType">
                                <el-select v-model="submitData.PayType" :disabled="dataReadonly" placeholder="请选择" style="width: 100%" size="small">
                                    <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="10">
                        <div class="grid-content bg-purple">
                            <el-form-item label="收货地址" prop="FullAddress">
                                <el-autocomplete
                                    :disabled="dataReadonly"
                                    v-model.trim="submitData.FullAddress"
                                    style="width: 100%"
                                    size="small"
                                    :fetch-suggestions="querySearch"
                                ></el-autocomplete>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="物流公司" prop>
                                <el-input :title="submitData.LogisticName" v-model="submitData.LogisticName" style="width: 100%" size="small" disabled></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            <el-form-item label="物流单号" prop="LogisticsOrderNo">
                                <el-input disabled size="small" v-model.trim="submitData.LogisticsOrderNo"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="5" v-if="isOrgShow">
                        <div class="grid-content bg-purple">
                            <el-form-item label="部门" prop="OrgId">
                                <el-input size="small" v-if="dataReadonly" disabled v-model="submitData.OrgName"></el-input>
                                <el-select
                                    style="width: 100%"
                                    size="small"
                                    v-else
                                    :disabled="dataReadonly"
                                    v-model="submitData.OrgId"
                                    filterable
                                    clearable
                                    reserve-keyword
                                    @change="orgChange($event)"
                                    @visible-change="orgVisibleChange($event)"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        v-for="optionItem in orgList"
                                        :key="optionItem.Id"
                                        :data-msg="optionItem"
                                        :label="optionItem.Name"
                                        :value="optionItem.Id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="customer-view">
                            <el-form-item label="客人要求" class="grid-content bg-purple">
                                <el-tooltip :content="submitData.Remark" placement="top" effect="light" v-if="submitData.Remark && dataReadonly">
                                    <el-input :disabled="dataReadonly" v-model="submitData.Remark" size="small"> </el-input>
                                </el-tooltip>
                                <el-input v-else :disabled="dataReadonly" v-model="submitData.Remark" size="small"> </el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="7">
                        <div class="discount-zone">
                            <div>
                                <el-select v-model="submitData.DiscountType" :disabled="dataReadonly || hasPaid" placeholder="请选择" size="small" style="width: 120px">
                                    <el-option v-for="item in discountOptions" :key="item.id" :label="item.value" :value="item.id"></el-option>
                                </el-select>
                            </div>
                            <el-input-number
                                v-if="submitData.DiscountType === 1"
                                size="small"
                                :disabled="dataReadonly || hasPaid"
                                v-model="submitData.DiscountAmount"
                                :min="0"
                                :step="0.01"
                                :precision="2"
                                controls-position="right"
                                :max="Number(allMoney)"
                                style="width: 134px"
                            >
                            </el-input-number>
                            <div class="percent-view" v-else-if="submitData.DiscountType === 2">
                                <el-input-number
                                    size="small"
                                    placeholder="请输入"
                                    :controls="false"
                                    :min="0"
                                    :max="100"
                                    :precision="2"
                                    :disabled="dataReadonly || hasPaid"
                                    v-model="submitData.DiscountRate"
                                ></el-input-number>
                                <span>%</span>
                            </div>
                            <div>
                                <span style="margin: 0 12px" v-if="!noFee">=</span>
                                实收金额：
                                <span class="discount-count">￥ {{ discountCount }}</span>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="customer-view" v-if="autoSeriesModel && autoSeriesModel.VIN">
                            <el-tag closable @click="vinSearch" @close="closeAutoSeries">{{ autoSeriesModel && autoSeriesModel.VIN ? autoSeriesModel.VIN : '' }}</el-tag>
                            <div class="customer-checked">
                                <el-checkbox v-model="isLockVIN">是否绑定配件与车型数据</el-checkbox>
                            </div>
                        </div>
                    </el-col>                 
                </el-row>
                <el-row :gutter="20" v-if="isUseSource">
                    <el-col :span="5" >
                        <div class="grid-content bg-purple">
                            <el-form-item label="订单来源" prop="CusSources">
                                <el-input size="small" v-if="dataReadonly" disabled v-model="submitData.CusSourcesName"></el-input>
                                <el-select
                                    style="width: 100%"
                                    size="small"
                                    v-else
                                    :disabled="dataReadonly"
                                    v-model="submitData.CusSources"
                                    filterable
                                    clearable
                                    reserve-keyword
                                    @change="sourceChange($event)"
                                    @visible-change="sourceVisibleChange($event)"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        v-for="optionItem in cusSourcesList"
                                        :key="optionItem.Value"
                                        :data-msg="optionItem"
                                        :label="optionItem.Text"
                                        :value="optionItem.Value"
                                    ></el-option>
                                </el-select>
                            </el-form-item>                        
                        </div>
                     </el-col>
                    </el-row>
            </el-form>
        </div>
        <div :class="showResultMsg ? 'section-title' : 'section-title section-magin'" @click="hideMsg" v-if="type != 1">
            <div>
                <span>搜索联盟配件结果</span>
                <span style="margin-left: 10px; font-size: 14px">{{ tableDataLength > 0 ? '(结果数：' + tableDataLength + ')' : '' }} </span>
                <el-link style="width: 120px" v-show="tableDataLength > 0" type="primary" @click="chooseAllAPsHandle">全部加入订单明细</el-link>
            </div>
            <div class="flex">
                <el-button icon="el-icon-setting" type="primary" class="search-set-btn" @click="showTableSetDialog()"></el-button>
                <div class="img-e-op" @click="showResultFunc" v-show="!showResultMsg">
                    <img src="../../../assets/images/down-e.png" />
                </div>
                <div class="img-e-op" @click="hideResultFunc" v-show="showResultMsg">
                    <img src="../../../assets/images/up-e.png" />
                </div>
            </div>
        </div>
        <div @click="hideMsg" v-show="showResultMsg" class="search-in-order" v-if="type != 3 && type != 1">
            <ux-grid
                ref="multipleTable"
                border=""
                height="350px"
                style="width: 100%"
                @cell-dblclick="dblChooseAps"
                @table-body-scroll="tableLoad"
                highlight-current-row
                show-overflow
                v-loading="searchLoading"
                :data="tableData"
                :row-class-name="tableRowClassName"
                @row-click="rowClick"
                empty-text=""
                @sort-change="sortChange"
            >
                <template v-for="(col,index) in columnShowSets">
                    <ux-table-column
                        v-bind:key="col.ColumnCode + index"
                        :field="col.ColumnCode"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :title="col.ColumnName"
                        resizable
                        :sortable="col.IsSort"
                        :remote-sort="col.IsSort"
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'APCode'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.APCode }}</i>
                            <i v-else>{{ scope.row.APCode }}</i>
                        </template>
                    </ux-table-column>
                    <ux-table-column
                        v-bind:key="col.ColumnCode + index"
                        :field="col.ColumnCode"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :title="col.ColumnName"
                        resizable
                        :sortable="col.IsSort"
                        :remote-sort="col.IsSort"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'GoodCode'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.GoodCode }}</i>
                            <i v-else>{{ scope.row.GoodCode }}</i>
                        </template>
                    </ux-table-column>
                    <ux-table-column
                        v-bind:key="col.ColumnCode + index"
                        :field="col.ColumnCode"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :title="col.ColumnName"
                        resizable
                        :sortable="col.IsSort"
                        :remote-sort="col.IsSort"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'GoodName'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.GoodName }}</i>
                            <i v-else>{{ scope.row.GoodName }}</i>
                        </template>
                    </ux-table-column>
                    <ux-table-column
                        v-bind:key="col.ColumnCode + index"
                        :field="col.ColumnCode"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :title="col.ColumnName"
                        resizable
                        :sortable="col.IsSort"
                        :remote-sort="col.IsSort"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'AutoSerise'"
                        show-overflow-tooltip
                    >
                        <template v-slot="{ row }">
                            <el-tooltip placement="top">
                                <div slot="content" v-html="$options.filters.AutoSeriseTextSplit(row.AutoSerise)"></div>
                                <div class="tooltip-div">{{ row.AutoSerise }}</div>
                            </el-tooltip>
                        </template>
                    </ux-table-column>
                    <ux-table-column
                        v-bind:key="col.ColumnCode + index"
                        :field="col.ColumnCode"
                        :width="col.Width > 0 ? col.Width + 'px' : '80px'"
                        :title="col.ColumnName"
                        resizable
                        :sortable="col.IsSort"
                        :remote-sort="col.IsSort"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'Inventory'"
                        show-overflow-tooltip
                    >
                        <template v-slot="{ row }">
                            <el-button v-if="row.LoadAfterData" icon="el-icon-loading" type="text"></el-button>
                            <span v-else>{{ row.MyGoodsId?row.MyInventory :'-' }}</span>
                        </template>
                    </ux-table-column>
                    <ux-table-column
                        v-bind:key="col.ColumnCode + index"
                        :field="col.ColumnCode"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :title="col.ColumnName"
                        resizable
                        :sortable="col.IsSort"
                        :remote-sort="col.IsSort"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'Remaining'"
                        show-overflow-tooltip
                    >
                        <template v-slot="{ row }">
                            <el-button v-if="row.LoadAfterData" icon="el-icon-loading" type="text"></el-button>
                            <span v-else class="out-active">
                                {{row.MyGoodsId?(row.StorageInventory + (isAddWaitIn ? row.POrderWaitInQuantity : 0) - row.OrderWaitOutQuantity):'-' }}
                            </span>
                        </template>
                    </ux-table-column>
                    <ux-table-column
                        v-bind:key="col.ColumnCode + index"
                        :field="col.ColumnCode"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :title="col.ColumnName"
                        resizable
                        :sortable="col.IsSort"
                        :remote-sort="col.IsSort"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'OrderWaitOutQuantity'"
                        show-overflow-tooltip
                    >
                        <template v-slot="{ row }">
                            <el-button v-if="row.LoadAfterData" icon="el-icon-loading" type="text"></el-button>
                            <span v-else>
                                <el-button @click="showNeedOutData(row)" type="text" style="padding: 0px" v-if="row.OrderWaitOutQuantity > 0">{{
                                    row.OrderWaitOutQuantity
                                }}</el-button>
                                <span v-else>{{  row.MyGoodsId?row.OrderWaitOutQuantity:'-'  }}</span>
                            </span>
                        </template>
                    </ux-table-column>
                    <ux-table-column
                        v-bind:key="col.ColumnCode + index"
                        :field="col.ColumnCode"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :title="col.ColumnName"
                        resizable
                        :sortable="col.IsSort"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'POrderWaitInQuantity'"
                        show-overflow-tooltip
                    >
                        <template v-slot="{ row }">
                            <el-button v-if="row.LoadAfterData" icon="el-icon-loading" type="text"></el-button>
                            <span v-else>
                                <el-button @click="showNeedInData(row)" type="text" style="padding: 0px" v-if="row.POrderWaitInQuantity > 0">{{
                                    row.POrderWaitInQuantity
                                }}</el-button>
                                <span v-else>{{  row.MyGoodsId?row.POrderWaitInQuantity:'-'  }}</span></span
                            >
                        </template>
                    </ux-table-column>
                    <ux-table-column
                        v-bind:key="col.ColumnCode + index"
                        :field="col.ColumnCode"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :title="col.ColumnName"
                        resizable
                        :sortable="col.IsSort"
                        :remote-sort="col.IsSort"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'UnionRemaining'"
                        show-overflow-tooltip
                    >
                        <template v-slot="{ row }">
                            <el-button v-if="row.LoadAfterData" icon="el-icon-loading" type="text"></el-button>
                            <span v-else class="out-active">
                                {{ row.MyGoodsId?(row.Count + (isAddWaitIn ? row.UnionWaitIn : 0) - row.UnionWaitOut):'-' }}
                            </span>
                        </template>
                    </ux-table-column>
                    <ux-table-column
                        v-bind:key="col.ColumnCode + index"
                        :field="col.ColumnCode"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :title="col.ColumnName"
                        resizable
                        :sortable="col.IsSort"
                        :remote-sort="col.IsSort"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'CreateTime'"
                        show-overflow-tooltip
                    >
                        <template v-slot="{ row }">
                            <el-button v-if="row.LoadAfterData" icon="el-icon-loading" type="text"></el-button>
                            <span v-else>{{ row.MyGoodsId?row.CreateTime :'-' }}</span>
                        </template>
                    </ux-table-column>                    
                    <ux-table-column
                        v-bind:key="col.ColumnCode + index"
                        :field="col.ColumnCode"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :title="col.ColumnName"
                        resizable
                        :sortable="col.IsSort"
                        :remote-sort="col.IsSort"
                        header-align
                        :prop="col.ColumnCode"
                        show-overflow-tooltip
                        v-else
                    >
                    </ux-table-column>
                </template>
            </ux-grid>
            <div class="invens-summary" v-if="isShowSummary && isStoDataShow">
                <span class="title">联盟商品在各仓库的库存数据：</span>
                <div v-for="item in summaryList" :key="item.Name" class="summary-item">
                    <span class="sname">【 {{ item.Name }} 】</span>
                    <span class="sname">库存数：</span>
                    <span class="scount"> {{ item.Count }} </span>
                </div>
            </div>
        </div>
        <!--    table    -->
        <div class="section-title" @click="hideMsg()">
            <div>订单商品明细</div>
        </div>
        <!-- table body -->
        <div id="infinite-list" @click="hideMsg()" class="sales-order-edit">
            <ux-grid
                ref="infiniteTable"
                :data="dataList"
                keep-source
                height="300px"
                :highlight-current-row="false"
                :edit-config="{ trigger: 'click', mode: 'row' }"
                :row-style="setRowStyle"
                row-id="rowkey"
                empty-text="暂无联盟订单商品明细"
            >
                <ux-table-column class-name="table-sort" type="index" title="序号" width="65" resizable></ux-table-column>
                <ux-table-column field="APCode" title="汽配编码" edit-render show-overflow-tooltip resizable>
                    <template v-slot:header="{ column }">
                        <div class="head-view">
                            <span class="color-red">*</span>
                            {{ column.title }}
                            <span class="sort-view">
                                <i :class="['el-icon-caret-top', { active: sortActive === 'top' }]" title="升序,从小到大排序" @click="changeTableSort('top', 'APCode')"></i>
                                <i
                                    :class="['el-icon-caret-bottom', { active: sortActive === 'bottom' }]"
                                    title="降序,从大到小排序"
                                    @click="changeTableSort('bottom', 'APCode')"
                                ></i>
                            </span>
                        </div>
                    </template>
                    <template v-slot="{ row }">
                        <div :class="['sales-apcode div-padding-12', { 'special-border': !row.APCode }]" @click="focusHandle('sapcode')">
                            <span class="sp-i" v-show="row.APCode">
                                <i title="配件信息" class="el-icon-info" @click.stop="showAPMsgDialog(row.MyGoodsId)"></i>
                            </span>
                            <span>{{ row.APCode ? row.APCode : '请点击选中汽配编码' }}</span>
                            <el-tag v-if="row.State == 1" class="tag" type="warning">已删除</el-tag>
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            style="width: 100%"
                            ref="sapcode"
                            :disabled="dataReadonly || scope.row.hasLock || scope.row.WarehousedCount > 0"
                            default-first-option
                            size="small"
                            v-model="scope.row.APCode"
                            value-key="APCode"
                            filterable
                            remote
                            reserve-keyword
                            placeholder="汽配编码"
                            @change="codeChange($event, scope.rowIndex)"
                            @visible-change="apCodeVisibleChange($event)"
                            :remote-method="
                                query => {
                                    searchCode(query, scope.row, scope.rowIndex);
                                }
                            "
                            v-select-scroll-more="searchCodeLoad"
                            popper-class="el-select-style-gray"
                            @keyup.right.native="keyEvent($event, 'APCode')"
                        >
                            <el-option
                                v-for="optionItem in codeList"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.APCode"
                                :value="optionItem.EntpTempGoodsId"
                            >
                                <div class="option-content">
                                    <div class="project-Name">{{ optionItem.APCode }}</div>
                                    <div class="project-Name">{{ optionItem.GoodName }}</div>
                                    <div class="project-Name">{{ optionItem.AutoSerise }}</div>
                                    <div class="project-Name" v-if="changeCodeConfig">
                                        {{ optionItem.GoodCode }}
                                    </div>
                                </div>
                            </el-option>
                            <el-option v-if="loading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="GoodNameItem" title="配件名称" edit-render show-overflow-tooltip resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div :class="['div-padding-12', { 'special-border': !row.GoodName }]" @click="focusHandle('partsNameSelect')">
                            {{ row.GoodName }}
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            size="small"
                            placeholder="配件名称"
                            ref="partsNameSelect"
                            v-model="scope.row.GoodName"
                            :disabled="dataReadonly|| scope.row.hasLock || scope.row.WarehousedCount > 0"
                            @keyup.right.native="keyEvent($event, 'GoodName')"
                            @keyup.left.native="keyEvent($event, 'GoodName')"
                            @focus="selectAutoHandle('partsNameSelect')"
                        ></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="AutoSeriseItem" title="车型" edit-render show-overflow-tooltip resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <el-tooltip effect="dark" :content="row.AutoSerise ? row.AutoSerise.toString() : ''" :disabled="!row.AutoSerise" placement="top">
                            <div :class="['div-padding-12', { 'special-border': !row.AutoSerise }]" @click="focusHandle('autoSeriseSelect')">
                                {{ row.AutoSerise }}
                            </div>
                        </el-tooltip>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            size="small"
                            v-model="scope.row.AutoSerise"
                            placeholder="车系"
                            :disabled="dataReadonly|| scope.row.hasLock || scope.row.WarehousedCount > 0"
                            @keyup.right.native="keyEvent($event, 'AutoSerise')"
                            @keyup.left.native="keyEvent($event, 'AutoSerise')"
                            @focus="selectAutoHandle('autoSeriseSelect')"
                            ref="autoSeriseSelect"
                        ></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="Origin" title="产地" v-if="isOriginShow" width="140" :edit-render="{ autofocus: '.el-input__inner' }" resizable key="origin">
                    <template v-slot="{ row }">
                        <div class="div-padding-12" @click="focusHandle('originRef')">{{ row.Origin }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            ref="originRef"
                            size="small"
                            v-model="scope.row.Origin"
                            @keyup.right.native="keyEvent($event, 'Origin')"
                            @keyup.left.native="keyEvent($event, 'Origin')"
                            @focus="selectAutoHandle('originRef')"
                            :disabled="dataReadonly|| scope.row.hasLock || scope.row.WarehousedCount > 0"
                        ></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="Size" title="规格" v-if="isSizeShow" width="120" resizable key="Size">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Size }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="OrderCount" title="数量" key="OrderCount" width="100" :edit-render="{ autofocus: '.el-input__inner' }" resizable>
                    <template v-slot="{ row }">
                        <div class="div-padding-12" @click="focusHandle('sapcode')">{{ row.OrderCount }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="sales-input-cell">
                            <el-input-number
                                type="number"
                                ref="countRef"
                                :min="1"
                                :precision="0"
                                controls-position="right"
                                size="small"
                                v-model="scope.row.OrderCount"
                                @change="priceChange"
                                @keyup.enter.native="keyEvent($event, 'Count')"
                                @keyup.right.native="keyEvent($event, 'Count')"
                                @keyup.left.native="keyEvent($event, 'Count')"
                                @focus="selectAutoHandle('countRef')"
                                :disabled="dataReadonly|| scope.row.hasLock || scope.row.WarehousedCount > 0"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Unit" title="单位" width="100" edit-render resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div :class="['div-padding-12', { 'special-border': !row.Unit }]" @click="focusHandle('unitSelect')">
                            {{ row.Unit }}
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="unitSelect"
                            :disabled="dataReadonly|| scope.row.hasLock || scope.row.WarehousedCount > 0"
                            default-first-option
                            size="small"
                            v-model="scope.row.Unit"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="单位"
                            @visible-change="unitVisibleChange($event)"
                            @keyup.right.native="keyEvent($event, 'Unit')"
                            @keyup.left.native="keyEvent($event, 'Unit')"
                            popper-class="el-select-style-gray"
                        >
                            <el-option v-for="optionItem in unitList" :key="optionItem.Value" :label="optionItem.Value" :value="optionItem.Value"></el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="CostPrice" title="联盟价" width="100">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.CostPrice }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Price" title="销售价" width="120" :edit-render="{ autofocus: '.el-input__inner' }" resizable>
                    <template v-slot:header="{ column }">
                        <el-tooltip effect="dark" placement="bottom" :tabindex="-1">
                            <div slot="content">
                                当配件商品有过销售历史且该客户有购买历史时，显示该客户购买配件商品的最新销售价格；
                                <br />若配件商品从未销售过，则不显示数值
                            </div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                                <span class="color-red">*</span>
                            </span>
                        </el-tooltip>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <el-tooltip effect="dark" placement="right">
                            <div slot="content">利润率：{{ row.Price != 0 && row.CostPrice != 0 ? (((row.Price - row.CostPrice) / row.CostPrice) * 100).toFixed(2) : 0 }}%</div>
                            <div
                                :class="[
                                    'div-padding-12',
                                    {
                                        'special-border': CheckLoseMoney(row.CostPrice, row.Price) || !row.Price
                                    }
                                ]"
                            >
                                <span
                                    :class="{
                                        'color-red': row.Price === 0 || row.Price < row.CostPrice
                                    }"
                                    >{{ row.Price }}</span
                                >
                            </div>
                        </el-tooltip>
                    </template>
                    <template v-slot:edit="scope">
                        <div
                            class="sales-input-cell"
                            v-if="(LoseMoneyValue && !dataReadonly && !(scope.row.WarehousedCount > 0)) || priceCanBeEdit"
                            :class="{
                                loseMoneyWarning: CheckLoseMoney(scope.row.CostPrice, scope.row.Price)
                            }"
                        >
                            <el-tooltip :disabled="!CheckLoseMoney(scope.row.CostPrice, scope.row.Price)" effect="light" placement="right">
                                <div slot="content">销售价低于成本价{{ LoseMoneyValue }}%</div>
                                <el-input-number
                                    ref="marketPirceRef"
                                    size="small"
                                    :min="0"
                                    :precision="2"
                                    :step="0.1"
                                    controls-position="right"
                                    v-model="scope.row.Price"
                                    placeholder="销售价"
                                    @input="priceChange"
                                    @keyup.left.native="keyEvent($event, 'Price')"
                                    @keyup.right.native="keyEvent($event, 'Price')"
                                    @focus="selectAutoHandle('marketPirceRef')"
                                    :disabled="dataReadonly"
                                >
                                </el-input-number>
                            </el-tooltip>
                        </div>
                        <div class="sales-input-cell" v-else>
                            <el-input-number
                                size="small"
                                :disabled="dataReadonly || scope.row.WarehousedCount > 0 || !priceCanBeEdit"
                                :min="0"
                                :precision="2"
                                :step="0.01"
                                controls-position="right"
                                v-model="scope.row.Price"
                                placeholder="销售价"
                                @input="priceChange"
                                @keyup.left.native="keyEvent($event, 'Price')"
                                @keyup.right.native="keyEvent($event, 'Price')"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column
                    field="BillingPrice"
                    title="开单价"
                    width="120"
                    v-if="isBPriceShow && type != 3"
                    :edit-render="{ autofocus: '.el-input__inner' }"
                    resizable
                    key="BillingPrice"
                >
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.BillingPrice }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="sales-input-cell">
                            <el-input-number
                                ref="billingPriceRef"
                                size="small"
                                :min="0"
                                :precision="2"
                                :step="0.1"
                                controls-position="right"
                                v-model="scope.row.BillingPrice"
                                placeholder="开单价"
                                @keyup.left.native="keyEvent($event, 'BillingPrice')"
                                @focus="selectAutoHandle('billingPriceRef')"
                                :disabled="dataReadonly"
                            >
                            </el-input-number>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="xszj" title="销售总价" width="120" resizable key="xszj">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            {{ ((row.Price ? row.Price : 0) * (row.OrderCount ? row.OrderCount : 0)).toFixed(2) }}
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="delState" title="出仓状态" width="100" resizable v-if="type == 3 || type == 4" key="delState">
                    <template v-slot="{ row }">
                        <div class="div-padding-12" v-if="row.IsDelivery">
                            <span style="color: #ff0097">已出仓</span>
                        </div>
                        <div class="div-padding-12" v-else>{{ row.WarehousedCount > 0 ? '部分出仓' : '未出仓' }}</div>
                    </template>
                </ux-table-column>

                <ux-table-column field="WarehousedCount" title="出仓数量" width="90" resizable v-if="type == 3 || type == 4" key="WarehousedCount">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            {{ row.WarehousedCount }}
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column title="操作" width="120" v-if="type !== 1" resizable>
                    <template v-slot="{ row, rowIndex }">
                        <div class="operate">
                            <el-button
                                size="small"
                                @click="delItem(rowIndex, row)"
                                icon="el-icon-delete"
                                :tabindex="-1"
                                v-if="dataList.length !== 1 && !dataReadonly && (type == 0 || type == 4) && row.WarehousedCount == 0"
                            ></el-button>
                            <el-button
                                size="small"
                                type="primary"
                                @click="addItem(true)"
                                icon="el-icon-plus"
                                v-if="rowIndex + 1 === dataList.length && !dataReadonly && (type == 0 || type == 2)"
                            ></el-button>
                            <el-button
                                size="small"
                                @click="upLock(rowIndex)"
                                :icon="row.hasLock ? 'el-icon-lock' : 'el-icon-unlock'"
                                v-if="isLock && lastRowIndex !== rowIndex"
                            ></el-button>
                        </div>
                    </template>
                </ux-table-column>
            </ux-grid>
        </div>
        <el-dialog
            :close-on-click-modal="false"
            title="配件在订数据"
            :visible.sync="inqHistoryVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
            width="900px"
        >
            <div v-if="inqHistoryVisible">
                <APInquiryHistory
                    ref="APInquiryHistory"
                    :EntpTempGoodsId="hisGoodsId"
                    :Source="0"
                    @closeDialog="
                        () => {
                            inqHistoryVisible = false;
                        }
                    "
                ></APInquiryHistory>
            </div>
        </el-dialog>
        <el-dialog
            :title="NeedITitle"
            :close-on-click-modal="false"
            :visible.sync="needInDataVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
            width="900px"
        >
            <div v-if="needInDataVisible">
                <APNeedInDatas ref="APNeedInDatas" :EntpTempGoodsId="EntpTempGoodsId" @closeDialog="needInDataVisible = false"></APNeedInDatas>
            </div>
        </el-dialog>
        <el-dialog
            :title="NeedOTitle"
            :close-on-click-modal="false"
            :visible.sync="needOutDataVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
            width="900px"
        >
            <div v-if="needOutDataVisible">
                <APNeedOutDatas ref="APNeedOutDatas" :EntpTempGoodsId="EntpTempGoodsId" @closeDialog="needOutDataVisible = false"></APNeedOutDatas>
            </div>
        </el-dialog>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="自定义列展示设置" @close="closeDialog" :visible.sync="tableSetsVisible" append-to-body width="600px">
            <div class="dialog-content" v-if="tableSetsVisible">
                <tableSets :tableCode="tableCode" @closeDialog="closeDialog"></tableSets>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="配件搜索"
            :visible.sync="searchVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-dc-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
            @close="closeSearchDialog"
        >
            <div class="dialog-content" v-if="searchVisible">
                <el-form ref="form" label-position="left" label-width="82px">
                    <el-form-item label="联合搜索">
                        <el-input
                            ref="search_0"
                            class="search-item"
                            style="width: 100%"
                            size="small"
                            clearable
                            v-model="searchData.JointSearch"
                            :placeholder="'用分隔符“' + (separator == ' ' ? '空格' : separator) + '”隔开'"
                            @focus="selectAutoHandle('search_0')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="配件编码">
                        <el-input
                            ref="search_1"
                            class="search-item"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.APCode"
                            placeholder="请输入配件编码"
                            @focus="selectAutoHandle('search_1')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="配件名称">
                        <el-autocomplete
                            ref="search_2"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.GoodName"
                            :fetch-suggestions="searchGoodName"
                            :debounce="500"
                            placeholder="请输入配件名称"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="适用车型">
                        <el-autocomplete
                            ref="search_3"
                            size="small"
                            style="width: 100%"
                            :debounce="500"
                            v-model="searchData.AutoSerise"
                            :fetch-suggestions="searchAutoSerise"
                            placeholder="请输入车型"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="精准车型" v-if="autoSeriesModel">
                        <el-tag closable style="width: 233px" @close="closeAutoSeries">
                            {{ autoSeriesModel.AutoSeries }}
                        </el-tag>
                        <el-checkbox v-model="isUseAS" style="margin-left: 10px"></el-checkbox>
                    </el-form-item>
                    <el-form-item label="互换码">
                        <el-input
                            ref="search_4"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.GoodCode"
                            placeholder="请输入互换码"
                            @focus="selectAutoHandle('search_4')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="汽配分类">
                        <el-select
                            ref="search_5"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.Cate"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            @visible-change="getGoodsType($event)"
                        >
                            <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配品牌">
                        <el-select
                            ref="search_6"
                            v-model="searchData.BrandName"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            size="small"
                            style="width: 100%"
                            @visible-change="getGoodsBrand($event)"
                        >
                            <el-option :key="item.Text" v-for="item in brandList" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="库存数">
                        <div class="flex">
                            <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol" clearable placeholder="符号">
                                <el-option key=">=" label=">=" value=">="></el-option>
                                <el-option key=">" label=">" value=">"></el-option>
                                <el-option key="<=" label="<=" value="<="></el-option>
                                <el-option key="<" label="<" value="<"></el-option>
                                <el-option key="=" label="=" value="="></el-option>
                                <el-option key="!=" label="!=" value="!="></el-option>
                                <el-option key="between" label="区间" value="between"></el-option>
                            </el-select>
                            <el-input
                                ref="search_7"
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.Invent1"
                                @focus="selectAutoHandle('search_7')"
                            ></el-input>
                            <el-input class="search-item" size="small" style="width: 90px" v-model.trim="searchData.Invent2" v-if="searchData.Symbol == 'between'"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="尺寸">
                        <el-input
                            ref="search_8"
                            class="search-item"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.Size"
                            placeholder="请输入尺寸"
                            @focus="selectAutoHandle('search_8')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="产地">
                        <el-input
                            ref="search_9"
                            class="search-item"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.Origin"
                            placeholder="请输入产地信息"
                            @focus="selectAutoHandle('search_9')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="自定义属性">
                        <el-input
                            ref="search_10"
                            class="search-item"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.GoodDesc"
                            placeholder="请输入属性值"
                            @focus="selectAutoHandle('search_10')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="查询公式">
                        <el-radio-group v-model="searchData.SearchType">
                            <el-radio :label="0">左等</el-radio>
                            <el-radio :label="1">全等</el-radio>
                            <el-radio :label="2">包含</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button v-if="isUseVIN" size="small" type="primary" class="search-btn" @click="vinSearch">VIN快搜 (F4)</el-button>
                    <el-button size="small" type="primary" @click="jointSets">设置查询条件</el-button>
                    <el-button size="small" @click="resetSearch">重置</el-button>
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="加入清单"
            width="400px"
            :visible.sync="rowVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="comfirm-ap-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="rowVisible" v-loading="rowFormLoading">
                <el-form label-position="left" label-width="70px" :model="rowForm">
                    <el-form-item label="汽配编码">
                        <el-input v-model="rowForm.APCode" disabled size="small" />
                    </el-form-item>
                    <el-form-item label="配件名称">
                        <el-input v-model="rowForm.GoodName" disabled size="small" />
                    </el-form-item>
                    <el-form-item label="车型">
                        <el-input v-model="rowForm.AutoSerise" disabled size="small" />
                    </el-form-item>
                    <el-form-item label="联盟价格">
                        <el-input v-model="rowForm.UnionPrice" disabled size="small" />
                    </el-form-item>
                    <el-form-item label="参考价格">
                        <el-input v-model="rowForm._referencePrice" disabled size="small" />
                    </el-form-item>
                    <el-form-item label="数量">
                        <el-input
                            :min="1"
                            @input="change($event)"
                            ref="confirm_0"
                            key="confirm_0"
                            v-model="rowForm._count"
                            size="small"
                            style="width: 100%"
                            @focus="selectAutoHandle('confirm_0')"
                            type="number"
                        />
                    </el-form-item>
                    <el-form-item label="价格">
                        <el-input
                            :min="0"
                            @input="change($event, 1)"
                            ref="confirm_1"
                            v-model="rowForm._price"
                            size="small"
                            style="width: 100%"
                            @focus="selectAutoHandle('confirm_1')"
                            type="number"
                        />
                    </el-form-item>
                    <el-form-item label="开单价" v-if="isBPriceShow">
                        <el-input
                            :min="0"
                            @input="change($event, 2)"
                            ref="confirm_2"
                            v-model="rowForm._biilPrice"
                            size="small"
                            @focus="selectAutoHandle('confirm_2')"
                            style="width: 100%"
                            type="number"
                        />
                    </el-form-item>
                </el-form>
            </div>
            <div class="dialog-footer">
                <el-button type="warning" size="small" @click="connectGoods" v-if="!rowForm.MyGoodsId" :disabled="rowFormLoading">立即关联</el-button>
                <el-button class="btn-primary" size="small" @click="rowConfirm" :disabled="rowFormLoading||!rowForm.MyGoodsId">加入清单(Enter)</el-button>
                <el-button size="small" @click="rowClose" :disabled="rowFormLoading">取消(ESC)</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="自定义搜索条件展示设置" @close="closeJointDialog" :visible.sync="jointSetVisible" append-to-body width="400px">
            <div class="dialog-content" v-if="jointSetVisible">
                <jointSets @closeDialog="closeJointDialog"></jointSets>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="主图"
            width="150px"
            :visible.sync="imageVisible && currentRow.MainImage !== ''"
            v-dialog-drag
            append-to-body
            lock-scroll
            :modal="false"
            id="ap-image-dialog"
            custom-class="image-item-dialog"
        >
            <div style="padding-top: 5px" v-if="imageVisible && currentRow.MainImage">
                <el-image
                    style="width: 100px; height: 100px"
                    :src="downloadUrl + currentRow.MainImage + '?imageView2/2/w/100'"
                    @click="getGoodsImages()"
                    fit="contain"
                    lazy
                ></el-image>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="VIN快搜" :visible.sync="vinSearchVisible" width="1000px">
            <div class="dialog-content" v-if="vinSearchVisible">
                <vinSearch ref="vinSearch" :VIN="autoSeriesModel && autoSeriesModel.VIN ? autoSeriesModel.VIN : ''" @closeDialog="closeVinSearch"></vinSearch>
            </div>
        </el-dialog>
        <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="srcList" :z-index="99999"/>
        <!-- 进度条 -->
        <el-progress v-if="searchApParams._visible" class="saveProgress" type="circle" :percentage="searchApParams._percentage" />
        <el-dialog :close-on-click-modal="false" title="提取商品信息" :visible.sync="tranAPVisible" width="1000px">
            <div v-if="tranAPVisible">
                <TranGoods :EntpGoodsId="goodsId" :Type="4" :IsReturnData="true" @closeDialog="closeTranAPDialog"></TranGoods>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="关联商品信息" :visible.sync="searchAPVisible" width="1000px">
            <div v-if="searchAPVisible">
                <SearchGoods :EntpGoodsId="goodsId" :Type="4" :IsReturnData="true" @closeDialog="CloseReleDialog"></SearchGoods>
            </div>
        </el-dialog>       
    </div>
</template>
<script>
import Vue from 'vue';
import breadcrumb from '@/components/common/breadcrumb';
import tableSets from '@/components/common/tableSets.vue';
import jointSets from '@/components/common/jointSets.vue';
import APMsg from '@/components/common/APMsg';
import mixin from '@/mixins/mixin';
import APNeedInDatas from '@/components/common/APNeedInDatas';
import APNeedOutDatas from '@/components/common/APNeedOutDatas';
import APInquiryHistory from '@/components/common/APInquiryHistory';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import vinSearch from '@/components/business/goods/vinSearchGoodsForUnion';
import TranGoods from '@/components/entpUnion/goodsManage/releGoods.vue';
import SearchGoods from '@/components/entpUnion/goodsManage/searchGoods.vue';
export default {
    mixins: [mixin],
    name: '',
    components: {
        APMsg,
        tableSets,
        APNeedInDatas,
        APNeedOutDatas,
        jointSets,
        APInquiryHistory,
        breadcrumb,
        ElImageViewer,
        vinSearch,
        TranGoods,
        SearchGoods        
    },
    watch: {
        $route(to, from) {
            if (to === this.$route) {
                this.submitData = {};
                this.allMoney = 0;
                this.allNum = 0;
                this.dataList = [];
            }
        },
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.search_0.focus();
                    this.searchIndex = 0;
                });
            }
        },
        isStartConfirm(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.confirm_0.focus();
                    this.confirmIndex = 0;
                });
            }
        },
        currentRow(newVal, oldVal) {
            if (this.isGoodsImgShow) {
                this.srcList = [];
                if (newVal && newVal.MainImage && newVal.MainImage != oldVal.MainImage) {
                    this.$nextTick(() => {
                        this.imageVisible = true;
                    });
                } else {
                    this.imageVisible = false;
                }
            }
        },
        dataList:{
            handler(newVal, oldVal){
                if((this.type!=1||this.type!=3)&&this.startAddChace)
                    this.addPageChace();
            },
            deep:true,
        },
        submitData:{
            handler(newVal, oldVal){
                if((this.type!=1||this.type!=3)&&this.startAddChace)
                    this.addPageChace();
            },
            deep:true,
        },        
    },
    data() {
        let checkPositive = this.$util.checkPositive;
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            downloadUrl: this.$util.QN_URL_BASE,
            confirmIndex: 0,
            searchIndex: 0,
            currentRow: {},
            dataindex: 0,
            datetime: '',
            tableCode: 'SearchUnionAPForAgent',
            isStartSearch: false,
            isStartConfirm: false,
            userMsg: userMsg,
            idList: [],
            addressList: [],
            typeList: [],
            brandList: [],
            postType: 0,
            isSearch: false,
            needConfirm: true,
            SIdList: [
                {
                    EmployeeId: userMsg.EmployeeId,
                    EmployeeName: userMsg.EmployeeName
                }
            ],
            EntpTempGoodsIdEdit: '',
            loading: false,
            searchLoading: false,
            saving: false,
            warehouseType: 0,
            dataReadonly: false,
            showOrderMsg: true,
            showResultMsg: false,
            APMsgVisible: false,
            searchVisible: false,
            jointSetVisible: false,
            inqHistoryVisible: false,
            historyPurVisible: false,
            needInDataVisible: false,
            needOutDataVisible: false,
            NeedITitle: '',
            NeedOTitle: '',
            isIntentShow: false,
            rowVisible: false,
            rowForm: {},
            allNum: 0,
            allMoney: 0,
            customerEditType: 1,
            submitData: {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                SId: userMsg.EmployeeId,
                SubmissionState: '0',
                UnionOrderId: '',
                ShipAmount: '',
                DiscountAmount: '',
                EntpCusId: '',
                PayType: '',
                ShipType: '',
                FullAddress: '',
                PhoneNum: '',
                Remark: '',
                DetailList: [],
                DiscountType: 0,
                DiscountRate: 0,
                OrgId: '',
                OrgName: '',
                Vin: '',
                IsNeedLock: false,
                CusSources:'',
                CusSourcesName: '',                
            },
            Limit: 10,
            customerList: [],
            DeliveryMethodList: [], // 发货方式列表
            payWayList: [],
            codeList: [],
            dataList: [],
            unitList: [],
            warehouseList: [], //仓库列表
            warehouseGoodsList: [], //入库商品列表
            type: 1, //  1 查看 2 编辑 3 新增 4 从库存配件管理过来的
            id: '',
            pageTitle: '',
            rules: {
                ShipType: [
                    {
                        required: true,
                        message: '请选择发货方式',
                        trigger: 'change'
                    }
                ],
                EntpCusId: [
                    {
                        required: true,
                        message: '请选择客户',
                        trigger: 'change'
                    }
                ],
                SId: [
                    {
                        required: true,
                        message: '请选择业务员',
                        trigger: 'change'
                    }
                ],
                PhoneNum: [
                    {
                        required: true,
                        message: '填写电话号码',
                        trigger: 'change'
                    }
                ],
                FullAddress: [
                    {
                        required: true,
                        message: '填写收货地址',
                        trigger: 'change'
                    }
                ],
                PayType: [
                    {
                        required: true,
                        message: '支付方式为必选项',
                        trigger: 'change'
                    }
                ],
                OrgId: [
                    {
                        required: true,
                        message: '请选择部门',
                        trigger: 'change'
                    }
                ],
                CusSources: [
                    {
                        required: true,
                        message: '请选择来源',
                        trigger: 'change'
                    }
                ]                  
            },
            permission: {},
            discountOptions: [
                {
                    id: 0,
                    value: '无优惠'
                },
                {
                    id: 1,
                    value: '优惠金额'
                },
                {
                    id: 2,
                    value: '整单优惠'
                }
            ],
            LoseMoneyValue: 0, //亏本指标
            priceCanBeZero: false,
            priceCanBeEdit: false,
            changeCodeConfig: false,
            // 是否预先加载汽配编码列表数据
            isPreloadApCodeList: false,
            selectedData: [],
            logisticsList: [],
            apcodeSource: null, // 用于处理取消编码请求操作
            // 用于客户名称列表，分页搜索
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于汽配编码列表，分页搜索功能
            codeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 加锁：选择商品完成回车或点加号后触发锁定不可修改
            hasLock: false,
            // 汽配编码排序标识
            sortActive: '',
            // 搜索配件弹框返回参数
            searchApParams: {
                _visible: false,
                _percentage: 0,
                _limit: 500,
                // 总数量
                _totalCount: 0
            },
            // 功能配置项：初始数量值
            initNumber: 1,
            //留余是否计算待入数据
            //否：留余数=库存数-待出库数
            //是：留余数=库存数-待出库数+待入库数
            isAddWaitIn: true,
            isBPriceShow: false, //开单价
            isOriginShow: false, //产地
            isSizeShow: false, //规格
            isOrgShow: false, //开单部门
            orgList: [], //
            tableData: [],
            tableDataLength: 0,
            searchData: {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                APCode: '',
                GoodCode: '',
                GoodName: '',
                GoodDesc: '',
                AutoSerise: '',
                Brand: '',
                BrandName: [],
                Size: '',
                Cate: [],
                page: 1,
                limit: 20,
                CId: '',
                SId: '',
                SortProp: '',
                SortType: '',
                JointSearch: '',
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                Origin: '',
                SearchType: 2,
                AutoSeriseId: ''
            },
            columnShowSets: [],
            tableSetsVisible: false,
            separator: '',
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            scrollTop: 0,
            scrollLeft: 0,
            isZeroInvenCanOrder: false,
            timer: null, //保存setTimeout定时器对象
            isRegister: false,
            optionLoading: false,
            goodNameOptions: [],
            goodNameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            autoSeriseOptions: [],
            autoSeriseForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            canSearch: true,
            rowFormLoading: false,
            isStoDataShow: false,
            isGoodsImgShow: false,
            showViewer: false,
            imageVisible: false,
            isUseVIN: false,
            vinSearchVisible: false,
            isUseAS: false,
            autoSeriesModel: null,
            matchCount: 0,
            isLockVIN: false,
            summaryList: [],
            isShowSummary: false,
            srcList: [],
            isUseSource: false,//是否启用销售开单显示来源
            cusSourcesList:[],    
            startAddChace:false,  
            tranAPVisible: false,//提取弹窗
            searchAPVisible:false,//关联弹窗
            goodsId:'',//提取或关联使用                 
        };
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        this.type = Number(this.$route.query.type);
        this.getSendWay();
        this.getPay();
        if (this.tableCode) {
            this.getSetsData();
            this.getJointSearchSets();
        }
    },
    mounted() {
        let that = this;
        that.id = that.$route.query.orderId;
        if (that.id) that.submitData.UnionOrderId = that.id;
        let salesOrderModel = that.$util.getLocalStorage('my_a_salesOrder');
        let datalist = that.$util.getLocalStorage('my_a_salesOrder_dataList');        
        that.getConfigByCodes().then(() => {
            switch (that.type) {
                case 0:
                    that.pageTitle = '创建联盟订单';
                    if (salesOrderModel || (datalist && datalist.length > 0)){
                        that.getDataFromChace();
                    }
                    break;                
                case 1:
                    that.pageTitle = '查看联盟订单';
                    that.dataReadonly = true;
                    that.getOrderDetail();
                    break;
                case 2:
                    that.pageTitle = '编辑联盟订单';
                    if (salesOrderModel || (datalist && datalist.length > 0)){
                        that.getDataFromChace();
                    }else{
                        that.getOrderDetail();
                    }
                    break;
                case 3:
                    //仅查看商品清单
                    that.pageTitle = '查看联盟订单商品清单';
                    that.dataReadonly = true;
                    that.needConfirm = false;
                    that.getOrderDetail();
                    break;
                case 4:
                    that.pageTitle = '修改联盟订单';
                    if (salesOrderModel || (datalist && datalist.length > 0)){
                        that.getDataFromChace();
                    }else{
                        that.getOrderDetail();
                    }
                    break;
                default:
                    break;
            }
        });

        //当表格出现滚动条后，编辑最后一条数据时，点击滚动条内底部的空白处单元格的编辑状态没有去除
        //为了解决这个bug在表格的父级监听点击事件来清除单元格激活状态
        let tablebody = document.querySelector('.elx-table--body-wrapper');
        tablebody.addEventListener('click', this.clearActived, false);

        if(!(salesOrderModel || (datalist && datalist.length > 0))) this.startAddChace=true;
    },
    computed: {
        noFee() {
            return this.submitData.ShipAmount && this.submitData.ShipAmount * 1 !== 0;
        },
        // 优惠后的金额
        discountCount() {
            let discountCount = this.submitData.DiscountAmount;
            let shipAmount = this.submitData.ShipAmount ? this.submitData.ShipAmount * 1 : 0;

            if (this.submitData.DiscountType === 2) {
                // 处理整单优惠
                discountCount = (this.submitData.DiscountRate / 100) * this.allMoney;
            }
            if (!discountCount || this.submitData.DiscountType === 0) {
                return (this.allMoney * 1 + shipAmount).toFixed(2);
            }
            return (this.allMoney * 1 - discountCount + shipAmount > 0 ? this.allMoney * 1 - discountCount + shipAmount : 0).toFixed(2);
        },
        // 是否加锁
        isLock() {
            return this.hasLock && [0, 2, 4].includes(this.type * 1);
        },
        // 列表数据最后一行下标
        lastRowIndex() {
            return Array.isArray(this.dataList) ? this.dataList.length - 1 : 0;
        },
        // 收款金额是否大于零，当为true时，不能修改优惠金额
        hasPaid() {
            return this.submitData.Paid && this.submitData.Paid * 1 > 0;
        },
        // 是否新增，编辑，修改
        isEdit() {
            return [0, 2, 4].includes(this.type * 1);
        }
    },
    filters: {
        AutoSeriseTextSplit(x) {
            if (~x.indexOf(',')) {
                return x.split(',').join('<br/>');
            } else {
                return x;
            }
        }
    },
    methods: {
        change(e, type) {
            let that = this;
            if (!that.rowVisible) {
                let fIdx = that.dataList.findIndex(f => f.EntpTempGoodsId === that.currentRow.EntpTempGoodsId);
                if (fIdx > -1) {
                    that.dataList[fIdx].BillingPrice = that.rowForm._biilPrice;
                    if (!that.dataList[fIdx].IsDelivery) that.dataList[fIdx].OrderCount = that.rowForm._count;
                    that.dataList[fIdx].Price = that.rowForm._price;
                }
            } else {
                if (type === 1) that.rowForm._biilPrice = e;
            }
        },
        handleKeyEvent(e) {
            let that = this;
            if (that.dataReadonly) return;
            let key = window.event.keyCode;
            if (key === 107) {
                if (!that.searchVisible) that.addItem(false);
                return;
            }
            if (key == 112) {
                e.preventDefault();
                that.goback();
                return;
            }
            if (key == 113) {
                e.preventDefault();
                if (!that.searchVisible) {
                    that.resetSearch();
                    that.searchVisible = true;
                    that.hideMsg();
                    that.showResultFunc();
                    if (that.rowVisible) {
                        that.isStartConfirm = false;
                        that.rowVisible = false;
                    }
                }
                that.isStartSearch = true;
                return;
            }
            if (key == 114) {
                e.preventDefault();
                if (!that.APMsgVisible) that.showAPMsgDialog();
                return;
            }
            if (key == 117) {
                e.preventDefault();
                if (!that.historyPurVisible) that.showPurHistories();
                return;
            }
            if (key == 122) {
                //F11
                if (!that.historyPurVisible && !that.inqHistoryVisible && !that.tableSetsVisible && !that.jointSetVisible && !that.APMsgVisible) {
                    e.preventDefault();
                    that.submitForm('0');
                    return;
                }
                return;
            }
            if (key == 123) {
                //F12
                if (!that.historyPurVisible && !that.inqHistoryVisible && !that.tableSetsVisible && !that.jointSetVisible && !that.APMsgVisible) {
                    e.preventDefault();
                    that.submitForm('1');
                    return;
                }
                return;
            }
            if (key === 13) {
                //Enter
                if (!that.historyPurVisible && !that.inqHistoryVisible && !that.tableSetsVisible && !that.jointSetVisible && !that.APMsgVisible&&!that.vinSearchVisible&&!that.tranAPVisible&&!that.searchAPVisible) {
                    e.preventDefault();
                    if (!that.searchVisible && that.currentRow && that.currentRow.EntpTempGoodsId) {
                        if (!that.rowVisible) {
                            that.dblChooseAps(that.currentRow);
                            if (that.searchVisible) {
                                that.searchVisible = false;
                                that.isStartSearch = false;
                            }
                        } else {
                            if (!that.rowFormLoading&&that.rowForm.MyGoodsId) that.rowConfirm();
                        }
                    } else if (
                        that.searchVisible &&
                        !that.rowVisible &&
                        that.$refs.search_5 &&
                        !that.$refs.search_5.visible &&
                        that.$refs.search_6 &&
                        !that.$refs.search_6.visible &&
                        that.canSearch
                    )
                        that.handleSearch();
                    that.canSearch = true;
                }
                return;
            }
            if (key === 27) {
                if(that.tranAPVisible||that.searchAPVisible)return;
                that.canSearch = true;
                if ((that.$refs.search_2 && that.$refs.search_2.suggestionVisible) || (that.$refs.search_3 && that.$refs.search_3.suggestionVisible)) {
                    if (that.$refs.search_2 && that.$refs.search_2.suggestionVisible) that.$refs.search_2.suggestions = [];
                    if (that.$refs.search_3.suggestionVisible) that.$refs.search_3.suggestions = [];
                    return;
                }
                //ESC
                if (!that.historyPurVisible && !that.inqHistoryVisible && !that.tableSetsVisible && !that.jointSetVisible && !that.APMsgVisible) {
                    e.preventDefault();
                    if (that.searchVisible && !that.rowVisible) {
                        that.searchVisible = false;
                        that.isStartSearch = false;
                    } else if (!that.searchVisible && that.rowVisible) {
                        that.rowVisible = false;
                        that.isStartConfirm = false;
                    }
                    if (that.APMsgVisible) that.APMsgVisible = false;
                }
                return;
            }
            //下键
            if (key == 40) {
                that.canSearch = true;
                if (!that.historyPurVisible && !that.inqHistoryVisible && !that.tableSetsVisible && !that.jointSetVisible && !that.APMsgVisible) {
                    e.preventDefault();
                    if (!that.rowVisible && !that.searchVisible) {
                        if (that.dataindex != that.tableDataLength - 1) {
                            if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                                that.dataindex++;
                            } else that.dataindex = 0;
                            let index = that.dataindex;
                            that.$nextTick(() => {
                                if (that.$refs.multipleTable) {
                                    that.currentRow = that.$refs.multipleTable.data[index];
                                    that.$refs.multipleTable.setCurrentRow(that.$refs.multipleTable.data[index]);
                                    that.$refs.multipleTable.scrollToRow(that.tableData[that.dataindex + 4]);
                                    that.$refs.multipleTable.scrollToRow(that.$refs.multipleTable.data[index]);
                                    that.getInvenDatas(that.currentRow);
                                }
                            });
                        }
                    } else if (!that.rowVisible && that.searchVisible) {
                        if (that.searchIndex != 10) {
                            if (
                                that.$refs.search_5 &&
                                !that.$refs.search_5.visible &&
                                that.$refs.search_6 &&
                                !that.$refs.search_6.visible &&
                                that.$refs.search_2 &&
                                !that.$refs.search_2.suggestionVisible &&
                                that.$refs.search_3 &&
                                !that.$refs.search_3.suggestionVisible
                            ) {
                                if (that.searchIndex == 5 || that.searchIndex == 6) {
                                    if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                                }
                                that.searchIndex += 1;
                                if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                            }
                        }
                    } else if (that.rowVisible && !that.searchVisible) {
                        if (that.confirmIndex != 2) {
                            that.confirmIndex += 1;
                            if (that.$refs[`confirm_` + that.confirmIndex]) that.$refs[`confirm_` + that.confirmIndex].focus();
                        }
                    }
                    return;
                }
                return;
            }
            //上键
            if (key == 38) {
                that.canSearch = true;
                if (!that.historyPurVisible && !that.inqHistoryVisible && !that.tableSetsVisible && !that.jointSetVisible && !that.APMsgVisible) {
                    e.preventDefault();
                    if (!that.rowVisible && !that.searchVisible) {
                        if (that.dataindex != 0) {
                            that.dataindex--;
                            let index = that.dataindex;
                            that.$nextTick(() => {
                                if (that.$refs.multipleTable) {
                                    that.currentRow = that.$refs.multipleTable.data[index];
                                    that.$refs.multipleTable.setCurrentRow(that.$refs.multipleTable.data[index]);
                                    that.$refs.multipleTable.setCurrentRow(that.$refs.multipleTable.data[index]);
                                    that.$refs.multipleTable.scrollToRow(that.tableData[that.dataindex - 5]);
                                    that.getInvenDatas(that.currentRow);
                                }
                            });
                        }
                    } else if (!that.rowVisible && that.searchVisible) {
                        if (that.searchIndex != 0) {
                            if (
                                that.$refs.search_5 &&
                                !that.$refs.search_5.visible &&
                                that.$refs.search_6 &&
                                !that.$refs.search_6.visible &&
                                that.$refs.search_2 &&
                                !that.$refs.search_2.suggestionVisible &&
                                that.$refs.search_3 &&
                                !that.$refs.search_3.suggestionVisible
                            ) {
                                if (that.searchIndex == 5 || that.searchIndex == 6) {
                                    if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                                }
                                that.searchIndex -= 1;
                                if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                            }
                        }
                    } else if (that.rowVisible && !that.searchVisible) {
                        if (that.confirmIndex != 0) {
                            that.confirmIndex -= 1;
                            if (that.$refs[`confirm_` + that.confirmIndex]) that.$refs[`confirm_` + that.confirmIndex].focus();
                        }
                    }
                    return;
                }
                return;
            }
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['kdbjsd', 'ddhhm', 'kdyjz', 'xskbzb', 'xsspjgwl', 'xgxsjg', 'lybsdr', 'syztsj', 'xskdxskdj', 'xskdxskdbm', 'kdspcd', 'kdspgg','xsddly'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            let rValue = data[i].RValue;
                            switch (code) {
                                case 'kdbjsd':
                                    this.hasLock = result;
                                    break;
                                case 'ddhhm':
                                    this.changeCodeConfig = result;
                                    break;
                                case 'kdyjz':
                                    this.isPreloadApCodeList = result;
                                    break;
                                case 'xskbzb':
                                    this.LoseMoneyValue = result ? Number(rValue) : 0;
                                    break;
                                case 'xsspjgwl':
                                    this.priceCanBeZero = result;
                                    break;
                                case 'xgxsjg':
                                    this.priceCanBeEdit = result;
                                    break;
                                case 'lybsdr':
                                    this.isAddWaitIn = !result;
                                    break;
                                case 'syztsj':
                                    this.isIntentShow = result;
                                    break;
                                case 'xskdxskdj':
                                    this.isBPriceShow = result;
                                    break;
                                case 'xskdxskdbm':
                                    this.isOrgShow = result;
                                    break;
                                case 'kdspcd': //是否出现产地
                                    this.isOriginShow = result;
                                    break;
                                case 'kdspgg': //是否出现规格
                                    this.isSizeShow = result;
                                    break;
                                case 'xsddly': //是否启用销售开单显示来源
                                    this.isUseSource = result;
                                    break;                                         
                            }
                        }
                    }
                    this.getUnionConfigs();
                    resolve();
                });
            });
        },
        getUnionConfigs() {
            return new Promise(resolve => {
                let codes = ['kcwlkyxd',  'zsspdgckkcs', 'kdcksptp', 'lmsyvin'];
                this.$util.getUnionConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'kcwlkyxd':
                                    this.isZeroInvenCanOrder = result;
                                    break;
                                case 'zsspdgckkcs':
                                    this.isStoDataShow = result;
                                    break;
                                case 'kdcksptp':
                                    this.isGoodsImgShow = result;
                                    break;
                                case 'lmsyvin':
                                    this.isUseVIN = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        // 自动选中输入框内容
        selectAutoHandle(ref) {
            clearTimeout(this.timer);
            //每次点击搜索配件后打开弹窗，select()事件没效果，有可能初始化控件后这个事件还没监听到input控件
            //所以这里用来nextTick 和 setTimeout做双重保证
            this.$nextTick(() => {
                // this.$refs[ref].select();
                this.timer = setTimeout(() => {
                    if (this.$refs[ref]) this.$refs[ref].select();
                }, 100);
            });
        },
        //通过获取当前事件同上，但是第一加载也有同样的问题，该方法没使用，只是做个记录
        selectAutoHandle2(e) {
            e.currentTarget.select();
        },
        // 编码排序
        changeTableSort(type, prop) {
            let sortArr = [];
            let listArr = this.dataList.filter(f => f[prop]);
            let otherArr = this.dataList.filter(f => !f[prop]);
            if (type === 'top') {
                this.sortActive = 'top';
                sortArr = listArr.sort((a, b) => a[prop].localeCompare(b[prop]));
            } else {
                this.sortActive = 'bottom';
                sortArr = listArr.sort((a, b) => b[prop].localeCompare(a[prop]));
            }
            this.dataList = [...sortArr, ...otherArr];
        },
        getSIdList() {
            this.$util.getCommonSIdList().then(data => {
                this.SIdList = data;
            });
        },
        getConfigData() {
            this.$util.searchGoodsUnit().then(res => {
                this.unitList = res;
            });
        },
        // 搜索
        showSearch() {
            this.resetSearch();
            this.searchVisible = true;
            this.isStartSearch = true;
            this.showResultFunc();
            this.hideMsg();
        },
        closeSearchDialog() {
            // this.searchVisible = false;
            this.isStartSearch = false;
        },
        // 配件信息
        showAPMsgDialog(id) {
            let that = this;
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.APMsgVisible = true;
            } else if (that.currentRow && that.currentRow.MyGoodsId) {
                this.EntpTempGoodsIdEdit = that.currentRow.MyGoodsId;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
            if (edit) {
                this.getOrderDetail();
            }
        },
        //历史采购
        showPurHistories() {
            let that = this;
            if (that.currentRow && that.currentRow.MyGoodsId) {
                this.EntpTempGoodsIdEdit = that.currentRow.MyGoodsId;
                this.historyPurVisible = true;
            }
        },
        // 配件信息
        hideMsg() {
            this.showOrderMsg = false;
        },
        showMsg() {
            this.showOrderMsg = true;
        },
        hideResultFunc() {
            this.showResultMsg = false;
        },
        showResultFunc() {
            this.showResultMsg = true;
        },
        // 数量或者价格变动
        priceChange() {
            let DetailList = this.dataList;
            let _allNum = 0;
            let _allMoney = 0;
            for (let i = 0; i < DetailList.length; i++) {
                _allNum += Number(DetailList[i].OrderCount);
                _allMoney += Number(DetailList[i].OrderCount * DetailList[i].Price ? (DetailList[i].OrderCount * DetailList[i].Price).toFixed(3) : 0);
            }
            this.allMoney = _allMoney.toFixed(2);
            this.allNum = _allNum;
        },
        closeDialog(edit) {
            this.tableSetsVisible = false;
        },
        // 获取详情
        getOrderDetail() {
            let that = this;
            that.$util
                .axiosGet({
                    url: '/api/EntpUnionOrders/GetUnionAgentOrderDetails',
                    data: {
                        EntpCusOId: that.id,
                        UnionId: this.submitData.UnionId
                    }
                })
                .then(res => {
                    let data = res.data;
                    let DetailList = data.DetailList;
                    data.LogisticItem = data.LogisticName;
                    that.submitData.UnionOrderId = data.EntpCusOId;
                    that.submitData.ShipAmount = data.ShipAmount;
                    that.submitData.DiscountAmount = data.DiscountAmount;
                    that.submitData.PayType = data.PayType;
                    that.submitData.ShipType = data.ShipType;
                    that.submitData.FullAddress = data.FullAddress;
                    that.submitData.PhoneNum = data.PhoneNum;
                    that.submitData.Remark = data.Remark;
                    that.submitData.LogisticName = data.LogisticName;
                    that.submitData.LogisticItem = data.LogisticItem;
                    that.submitData.LogisticsOrderNo = data.LogisticsOrderNo;
                    that.submitData.DiscountType = data.DiscountType;
                    that.submitData.DiscountRate = data.DiscountRate;
                    that.submitData.OrgId = data.OrgId;
                    that.submitData.OrgName = data.OrgName;
                    that.submitData.EntpCusId = data.EntpCusId;
                    that.submitData.EntpCusName = data.EntpCusName;
                    if(that.isUseSource&&data.CusSources){
                        that.submitData.CusSources = data.CusSources;
                        that.submitData.CusSourcesName = data.CusSourcesName;
                        that.cusSourcesList=[];
                        that.cusSourcesList.push({Text:data.CusSourcesName,Value:data.CusSources});
                    }

                    if (data.Vin) {
                        if (!that.autoSeriesModel) that.autoSeriesModel = {};
                        that.autoSeriesModel.VIN = data.Vin;
                        that.autoSeriesModel.AutoSeries = data.AutoSeries;
                        that.autoSeriesModel.AutoSeriesId = data.AutoSeriesId;
                        that.isLockVIN = data.IsNeedLock;
                    }

                    this.customerList.push({
                        EntpCusId: data.EntpCusId,
                        EntpCusName: data.EntpCusName,
                        CallNum: data.PhoneNum,
                        FullAddress: data.FullAddress
                    });
                    let i = that.SIdList.findIndex(item => {
                        if (item.EmployeeId == res.data.SId) {
                            return true;
                        }
                    });
                    if (i == -1) {
                        that.SIdList.push({
                            EmployeeId: res.data.SId,
                            EmployeeName: res.data.SName
                        });
                    }
                    if (!that.submitData.SId) that.submitData.SId = that.userMsg.EmployeeId;

                    if (that.isOrgShow && res.data.OrgId) {
                        that.orgList.push({
                            Id: data.OrgId,
                            Name: data.OrgName
                        });
                    }

                    let _allNum = 0;
                    let _allMoney = 0;
                    for (let i = 0; i < DetailList.length; i++) {
                        that.$set(DetailList[i], 'Price', DetailList[i].Price);
                        _allNum += Number(DetailList[i].OrderCount);
                        _allMoney += DetailList[i].OrderCount * DetailList[i].Price ? DetailList[i].OrderCount * DetailList[i].Price : 0;
                        DetailList[i].GoodNameItem = DetailList[i].GoodName;
                        DetailList[i].AutoSeriseItem = DetailList[i].AutoSerise;
                        DetailList[i].hasLock = this.hasLock;
                    }

                    that.allMoney = _allMoney.toFixed(2);
                    that.allNum = _allNum;
                    that.dataList = DetailList;
                });
        },
        // 提交销售单
        submitForm(SubmissionState) {
            this.$refs['formMsg'].validate(valid => {
                if (valid) {
                    let _dataList = this.dataList;
                    if (this.submitData.DiscountType === 2) {
                        // 处理整单优惠
                        this.submitData.DiscountAmount = (this.submitData.DiscountRate / 100) * this.allMoney;
                    }
                    if (this.submitData.DiscountAmount > this.allMoney) {
                        this.$util.warningMsg('优惠金额不能大于订单总额');
                        return;
                    }
                    this.submitData.DetailList = _dataList;

                    let checkRepeat = this.checkRepeatAndReturnData();
                    if (checkRepeat.hasRepeat) {
                        this.$confirm('订单含有重复商品项，是否需要累加', '', {
                            type: 'error',
                            distinguishCancelAndClose: true
                        })
                            .then(() => {
                                // 覆盖数据
                                this.dataList = checkRepeat.row;
                                this.submitData.DetailList = checkRepeat.row;

                                this.submit(SubmissionState);
                            })
                            .catch(() => {});
                    } else {
                        this.submit(SubmissionState);
                    }
                } else {
                    this.$util.warningMsg('有必填项未填写');
                    this.showMsg();
                }
            });
        },
        submit(SubmissionState) {
            let that = this;
            let _dataList = this.submitData.DetailList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].APCode) {
                    this.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    this.$util.warningMsg('请填写配件名称');
                    return;
                }
                if (_dataList[i].State != 0) {
                    this.$util.warningMsg('商品【' + _dataList[i].GoodName + '（' + _dataList[i].APCode + '）' + '】已删除');
                    return;
                }
                if (!_dataList[i].AutoSerise) {
                    this.$util.warningMsg('请填写车型');
                    return;
                }
                if (!_dataList[i].OrderCount || _dataList[i].OrderCount < 0) {
                    this.$util.warningMsg('请填写正确的数量');
                    return;
                }
                if (!this.isZeroInvenCanOrder) {
                    if (_dataList[i].Count < _dataList[i].OrderCount) {
                        this.$util.warningMsg('下单数不能超过可购数量');
                        return;
                    }
                }
                if (!_dataList[i].Unit) {
                    this.$util.warningMsg('请填写单位');
                    return;
                }
                if (!this.priceCanBeZero && !_dataList[i].Price) {
                    this.$util.warningMsg('销售价不能小于0');
                    return;
                }
                if (!this.priceCanBeZero) {
                    if (!_dataList[i].Price && !_dataList[i].Price) {
                        this.$util.warningMsg('请填写销售价');
                        return;
                    }
                    if (_dataList[i].Price == 0) {
                        this.$util.warningMsg('销售价不能为0');
                        return;
                    }
                }
            }

            this.submitData.Vin = this.autoSeriesModel && this.autoSeriesModel.VIN ? this.autoSeriesModel.VIN : '';
            this.submitData.IsNeedLock = this.isLockVIN;

            this.saving = true;
            if (SubmissionState == '0' || SubmissionState == '1') {
                this.submitData.SubmissionState = SubmissionState;
            }
            let url = '/api/EntpUnionOrders/SaveUnionAgentOrder';
            this.$util
                .axiosPost({
                    url: url,
                    data: this.submitData
                })
                .then(() => {
                    this.$store.commit('updateNeedRefresh', true);
                    this.needConfirm = false;
                    if (SubmissionState == '0') this.$util.successMsg('保存联盟代发单成功');
                    else this.$util.successMsg('提交联盟代发单成功');

                    this.removePageChace();

                    setTimeout(() => {
                        this.$router.push('/entpUnion/unionOrdersManage/myAgentOrders');
                    }, 2000);
                })
                .catch(() => {
                    this.saving = false;
                });
        },
        // 检查是否有重复项及返回已合并数量的数据
        checkRepeatAndReturnData() {
            let [list, row, hasRepeat] = [this.submitData.DetailList, [], false];
            list.forEach(item => {
                let index = row.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId);
                if (index > -1) {
                    hasRepeat = true;
                    row[index].OrderCount = Number(row[index].OrderCount) + Number(item.OrderCount);
                } else {
                    row.push(Object.assign({}, item));
                }
            });
            return {
                hasRepeat,
                row
            };
        },
        // 删除某行
        delItem(index, item) {
            let that = this;
            if (that.dataList.length != 1) {
                that.dataList.splice(index, 1);
            }
            that.priceChange();
            // that.addPageChace(); //添加销售订单缓存

            let sIdx = that.tableData.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId);
            if (sIdx > -1) {
                that.tableData[sIdx].IsSelected = false;
            }
        },
        // 添加一行
        addItem(addPageChace) {
            if (this.dataReadonly) return;
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].APCode) {
                    this.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    this.$util.warningMsg('请填写配件名称');
                    return;
                }
                if (!_dataList[i].AutoSerise) {
                    this.$util.warningMsg('请填写车型');
                    return;
                }
                if (!_dataList[i].Unit) {
                    this.$util.warningMsg('请填写单位');
                    return;
                }
                if (!this.priceCanBeZero) {
                    if (!_dataList[i].Price) {
                        this.$util.warningMsg('请填写销售价');
                        return;
                    }
                }
            }
            // if (addPageChace) {
            //     this.addPageChace(); //添加销售订单缓存
            // }

            // 上锁
            if (this.isLock) {
                this.dataList.forEach(ele => {
                    ele.hasLock = true;
                });
            }

            this.codeForm.key = '';
            this.codeForm.Page = 1;
            this.codeForm.Limit = 10;
            this.codeForm.stopLoad = false;

            this.dataList.push({
                MyInventory: 0, //商品总数量
                EntpTempGoodsId: '',
                APCode: '',
                GoodName: '',
                GoodNameItem: '',
                AutoSerise: '',
                AutoSeriseItem: '',
                OrderCount: this.initNumber,
                Count: 0,
                Price: '',
                CostPrice: 0,
                Unit: '',
                Remark: '',
                CodeRepeat: false,
                WarehousedCount: 0,
                State: 0,
                // 是否可编辑，用于报价转销售情况时新增数据情况
                canEdit: this.type == 4,
                BillingPrice: '',
                Origin: '',
                Size: ''
            });

            this.priceChange();
            setTimeout(() => {
                this.$refs.infiniteTable.scrollToRow(this.dataList[this.dataList.length - 1]);
                this.$refs.infiniteTable.setActiveRow(this.dataList[this.dataList.length - 1]);
                if (this.dataList.length > 1) {
                    let ilEle = document.getElementsByClassName('business-content')[0];
                    ilEle.scrollTop = ilEle.scrollHeight;
                }
            }, 100);

            let that = this;
            that.$nextTick(() => {
                setTimeout(function () {
                    that.$refs.sapcode.focus();
                }, 200);
            });
        },
        // 解锁
        upLock(index) {
            this.$set(
                this.dataList,
                index,
                Object.assign({}, this.dataList[index], {
                    hasLock: !this.dataList[index].hasLock
                })
            );
        },
        // 点击展开下拉框
        focusHandle(type) {
            if (type === 'sapcode') {
                setTimeout(() => {
                    this.$refs[`sapcode`].focus();
                }, 200);
            }
            if (type === 'partsNameSelect') {
                setTimeout(() => {
                    this.$refs[`partsNameSelect`].focus();
                }, 200);
            }
            if (type === 'autoSeriseSelect') {
                setTimeout(() => {
                    this.$refs[`autoSeriseSelect`].focus();
                }, 200);
            }
            if (type === 'originRef') {
                setTimeout(() => {
                    this.$refs[`originRef`].focus();
                }, 200);
            }
            if (type === 'countRef') {
                setTimeout(() => {
                    this.$refs[`countRef`].focus();
                }, 200);
            }
            if (type === 'unitSelect') {
                setTimeout(() => {
                    this.$refs[`unitSelect`].focus();
                }, 200);
            }
        },
        //添加页面缓存
        addPageChace() {
            this.removePageChace();
            this.$set(this.submitData, 'autoSeriesModel', this.autoSeriesModel);
            this.$set(this.submitData, 'IsNeedLock', this.isLockVIN);
            this.$util.setLocalStorage('my_a_salesOrder', this.submitData);
            this.$util.setLocalStorage('my_a_salesOrder_dataList', this.dataList);
        },
        //清除页面缓存
        removePageChace() {
            this.$util.clearLocalStorage('my_a_salesOrder');
            this.$util.clearLocalStorage('my_a_salesOrder_dataList');
        },
         //从缓存中读取数据
        getDataFromChace() {
            let salesOrderModel = this.$util.getLocalStorage('my_a_salesOrder');
            let datalist = this.$util.getLocalStorage('my_a_salesOrder_dataList');
            if (salesOrderModel) {
                if(this.isUseSource&&salesOrderModel.CusSources){
                    this.cusSourcesList=[];
                    this.cusSourcesList.push({Text:salesOrderModel.CusSourcesName,Value:salesOrderModel.CusSources}); 
                }
                this.submitData = salesOrderModel;
                let isexit = this.customerList.find(e => e.EntpCusId == salesOrderModel.EntpCusId);
                if (!isexit) {
                    this.customerList.push({
                        EntpCusId: salesOrderModel.EntpCusId,
                        EntpCusName: salesOrderModel.EntpCusName,
                        CallNum: salesOrderModel.PhoneNum,
                        FullAddress: salesOrderModel.FullAddress
                    });
                }

                isexit=this.SIdList.find(e=>e.EmployeeId==salesOrderModel.SId);
                if (!isexit) {
                    this.SIdList.push({
                        EmployeeId: salesOrderModel.SId,
                        EmployeeName: salesOrderModel.SName
                    });
                }

                this.isLockVIN=salesOrderModel.IsNeedLock;
                if(salesOrderModel.autoSeriesModel){
                    this.autoSeriesModel=salesOrderModel.autoSeriesModel;
                }  
                if (this.isOrgShow && salesOrderModel.OrgId) {
                    this.orgList.push({
                        Id: salesOrderModel.OrgId,
                        Name: salesOrderModel.OrgName
                    });
                }                                           
            }
            if (salesOrderModel && salesOrderModel.WarehouseId) {
                let isexit = this.warehouseList.find(e => e.WarehouseId == salesOrderModel.WarehouseId);
                if (!isexit)
                    this.warehouseList.push({
                        WarehouseId: salesOrderModel.WarehouseId,
                        WarehouseName: salesOrderModel.WarehouseName,
                        Type: salesOrderModel.WarehouseType
                    });
            } else {
                this.getdefaultWarehouses();
            }

            if (datalist && datalist.length > 0) {
                let _allNum = 0;
                let _allMoney = 0;
                for (let i = 0; i < datalist.length; i++) {
                    _allNum += Number(datalist[i].Count);
                    _allMoney += datalist[i].Count * datalist[i].Price ? datalist[i].Count * datalist[i].Price : 0;
                    datalist[i].hasLock = this.hasLock;
                }
                this.allMoney = _allMoney;
                this.allNum = _allNum;
                this.dataList = datalist;
            }
            this.startAddChace=true;
        },
        //从缓存中获取默认出仓仓库
        getdefaultWarehouses() {
            if (this.dataReadonly) return;
            return new Promise(resolve => {
                this.$util.GetEntpCache({CacheKey:'defaultInWarehouses'},true).then(result => {
                    if (result) {
                        let data =JSON.parse(result)
                        let isexit = this.warehouseList.find(e => e.WarehouseId == data.WarehouseId);
                        if (!isexit) {
                            this.warehouseList.push({
                                WarehouseId: data.WarehouseId,
                                WarehouseName: data.WarehouseName,
                                Type: data.WarehouseType,
                                Address:data.Address
                            });
                        }

                        this.$set(this.submitData, 'WarehouseId', data.WarehouseId);
                        this.$set(this.submitData, 'WarehouseName', data.WarehouseName);
                        this.$set(this.submitData, 'WarehouseAddr', data.Address);

                        this.warehouseType = data.WarehouseType;
                    }
                    resolve();
                });
            });
        },       

        /**
         * 获取默认数据
         * ShipType 发货方式
         * PayType 结算方式
         * FullAddress 收货地址
         */
        getDefaultData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpCustomers/GetCustOrderNewsData',
                    data: {
                        cid: this.submitData.EntpCusId,
                        type: '0',
                        EntpId: this.userMsg.EntpId
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        this.submitData.ShipType = data.ShipType;
                        this.submitData.PayType = data.PayType;
                        this.submitData.FullAddress = data.FullAddress;
                    }
                });
        },
        // 搜索汽配编码
        searchCode(key, item, index) {
            // 取消请求
            if (this.apcodeSource) {
                this.apcodeSource.cancel();
            }
            if (![undefined].includes(key)) {
                this.codeForm.Page = 1;
                this.codeForm.stopLoad = false;
                this.codeForm.key = key;
                this.codeForm.rowIndex = index;
                this.codeList = [];
            }
            if (item) {
                item.APCode = key;
            }
            if (this.codeForm.stopLoad) return;
            this.apcodeSource = this.axios.CancelToken.source();
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpUnionGoods/GetUnionGoodsItemsForAgent',
                    data: {
                        UnionId: this.submitData.UnionId,
                        APCode: this.codeForm.key,
                        EntpCusId: this.submitData.EntpCusId,
                        Page: this.codeForm.Page,
                        Limit: this.codeForm.Limit
                    },
                    hideLoading: true
                })
                .then(res => {
                    let that = this;
                    this.loading = false;
                    if (!res.data) {
                        if (this.codeForm.Page == 1 && that.codeForm.key) {
                            let option = this.$refs[`sapcode`].options[0].$el;
                            if (option) {
                                option.onclick = function () {
                                    that.codeChange(that.codeForm.key, that.codeForm.rowIndex);
                                };
                            }
                        }
                        return;
                    }
                    this.codeForm.stopLoad = res.data.length < this.codeForm.Limit;
                    this.codeList = this.$util.uniqueArr(this.codeList, res.data);

                    //ps 入过接口可以按条件的相似度来排序的化，下面的逻辑可以去除，比如查询条件为：1121时
                    that.$nextTick(() => {
                        if (that.codeForm.key) {
                            let hit = res.data.findIndex(c => c.APCode == that.codeForm.key);
                            if (hit != -1) {
                                hit = hit + (that.codeList.length - res.data.length);
                                let option = that.$refs[`sapcode`].options[hit].$el;
                                if (option) {
                                    option.onclick = function () {
                                        that.codeChange(that.codeForm.key, that.codeForm.rowIndex, option);
                                    };
                                }
                            }
                        }
                    });
                });
        },
        // 汽配编码列表，加载更多
        searchCodeLoad() {
            if (!this.loading) {
                this.codeForm.Page += 1;
                this.searchCode();
            }
        },
        //结算方式
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        // 获取发货方式
        getSendWay() {
            this.$util.getSendWay().then(data => {
                this.DeliveryMethodList = data;
            });
        },
        //检查是否亏本
        CheckLoseMoney(costPrice, salePric) {
            let that = this;
            if (!that.LoseMoneyValue || !costPrice || !salePric) return false;

            let val = Number(salePric) * ((100 - that.LoseMoneyValue) / 100) < Number(costPrice);
            return val;
        },
        // 编码改变
        codeChange(value, index, option) {
            if (option) {
                option.onclick = function () {};
            }
            let _list = this.codeList;
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].EntpTempGoodsId == value) {
                    this.dataList[index].APCode = _list[i].APCode;
                    this.dataList[index].CostPrice = _list[i].UnionPrice;
                    this.dataList[index].Price = _list[i].ReferencePrice;
                    this.dataList[index].EntpTempGoodsId = _list[i].EntpTempGoodsId;
                    this.dataList[index].MyGoodsId = _list[i].MyGoodsId;
                    this.dataList[index].GoodName = _list[i].GoodName;
                    this.dataList[index].GoodNameItem = _list[i].GoodName;
                    this.dataList[index].Unit = _list[i].Unit;
                    this.dataList[index].Origin = _list[i].Origin;
                    this.dataList[index].Count = _list[i].Count;
                    this.dataList[index].AutoSerise = _list[i].AutoSerise;
                    this.dataList[index].AutoSeriseItem = _list[i].AutoSerise;
                    this.dataList[index].MyInventory = _list[i].MyInventory;
                    this.dataList[index].State = 0;
                    this.dataList[index].BillingPrice = _list[i].ReferencePrice;
                    this.dataList[index].Size = _list[i].Size;
                    break;
                }
            }
            this.priceChange();
        },
        //查地址列表
        querySearch(queryString, cb) {
            var restaurants = this.addressList;
            cb(restaurants);
        },
        //业务员改变
        sIdChange(value) {
            let _list = this.SIdList;
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].EmployeeId == value) {
                    this.submitData.SName = _list[i].EmployeeName;
                    return;
                }
            }
        },
        //单位下拉框显示时触发event
        unitVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.unitList.length == 0) that.getConfigData();
            }
        },
        //当汽配件编码下拉框出现时触发
        apCodeVisibleChange(event) {
            let that = this;
            if (event && that.codeList.length == 0 && that.isPreloadApCodeList) {
                that.searchCode('');
            }
        },
        //当业务员下拉框出现时触发
        siVisibleChange(event) {
            let that = this;
            if (event) {
                that.getSIdList();
            }
        },
        // 设置展示行样式
        setRowStyle(param) {
            const { row, index } = param;
            let rowArr = this.dataList.filter(f => f.EntpTempGoodsId === row.EntpTempGoodsId);
            if (rowArr.length > 1) {
                return `background-color: #FFE8E8`;
            }
        },
        //手动清除单元格激活状态
        clearActived(e) {
            if (e.target.className == 'elx-table--body-wrapper body--wrapper') {
                this.$refs.infiniteTable.clearActived();
            }
            e.stopPropagation();
            e.preventDefault();
        },
        keyEvent(ev, code, row, index) {
            let that = this;
            if (ev.key == 'ArrowLeft') {
                switch (code) {
                    case 'GoodName':
                        that.$refs[`sapcode`].focus();
                        break;
                    case 'AutoSerise':
                        that.$refs[`partsNameSelect`].focus();
                        break;
                    case 'Origin':
                        that.$refs[`autoSeriseSelect`].focus();
                        break;
                    case 'Count':
                        if (that.$refs[`originRef`]) that.$refs[`originRef`].focus();
                        else that.$refs[`partsNameSelect`].focus();
                        break;
                    case 'Unit':
                        if (that.$refs[`unitSelect`]) that.$refs[`unitSelect`].blur();
                        that.$refs[`countRef`].focus();
                        break;
                    case 'Price':
                        that.$refs[`unitSelect`].focus();
                        break;
                    case 'BillingPrice':
                        that.$refs[`marketPirceRef`].focus();
                        break;
                }
            } else if (ev.key == 'ArrowRight') {
                switch (code) {
                    case 'APCode':
                        if (that.$refs[`sapcode`]) that.$refs[`sapcode`].blur();
                        that.$refs[`partsNameSelect`].focus();
                        break;
                    case 'GoodName':
                        that.$refs[`autoSeriseSelect`].focus();
                        break;
                    case 'AutoSerise':
                        if (that.$refs[`originRef`]) that.$refs[`originRef`].focus();
                        else that.$refs[`countRef`].focus();
                        break;
                    case 'Origin':
                        that.$refs[`countRef`].focus();
                        break;
                    case 'Count':
                        that.$refs[`unitSelect`].focus();
                        break;
                    case 'Unit':
                        if (that.$refs[`unitSelect`]) that.$refs[`unitSelect`].blur();
                        that.$refs[`marketPirceRef`].focus();
                        break;
                    case 'Price':
                        if (that.$refs[`billingPriceRef`]) that.$refs[`billingPriceRef`].focus();
                        break;
                }
            }
        },
        orgVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.orgList.length <= 1)
                    that.$util.getParentOrgs().then(data => {
                        that.orgList = data;
                    });
            }
        },
        orgChange(val) {
            let that = this;
            if (val) {
                for (let i = 0; i < that.orgList.length; i++) {
                    if (val == that.orgList[i].Id) {
                        that.submitData.OrgName = that.orgList[i].Name;
                        break;
                    }
                }
            } else {
                that.submitData.OrgName = '';
            }
        },
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTBSetsForShow(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    this.columnShowSets.push(colums);
                });
            });
        },
        getJointSearchSets() {
            this.$util.getJointSearchSetsData(true).then(data => {
                data.forEach(item => {
                    if (item.IsSeparator) {
                        this.separator = item.Separator;
                        return;
                    }
                });
            });
        },
        /**
         * 表格滚动
         * 只有在滚动到底部，并且下方还有数据的情况下刷新
         */
        tableLoad({ scrollTop, scrollLeft }, event) {
            var t = event.currentTarget.scrollTop; // 表格内容已滚动的高度
            var s = event.currentTarget.scrollHeight; // 表格内容撑起的高度
            var c = event.currentTarget.clientHeight; // 表格视窗高度 即wraper
            if (scrollTop > this.scrollTop && !this.stopFresh && t + c >= s - 50) {
                //第一页还没有数据就去请求第二页，想太多了吧`(*>﹏<*)′
                if (this.tableData && this.tableData.length > 0) {
                    this.searchData.page += 1;
                    if (scrollTop !== 0) this.scrollTop = scrollTop;
                    this.scrollLeft = scrollLeft;
                } else {
                    this.searchData.page = 1;
                    this.scrollTop = 0;
                    this.scrollLeft = 0;
                }
                this.getAPTableData();
            }
        },
        getAPTableData() {
            if (this.searchData.Symbol) {
                if (this.searchData.Symbol == 'between') {
                    if (isNaN(this.searchData.Invent1)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                    if (isNaN(this.searchData.Invent2)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                } else {
                    if (isNaN(this.searchData.Invent1)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                }
            } else {
                if (!this.searchData.Invent1) this.searchData.Invent1 = 0;
                if (!this.searchData.Invent2) this.searchData.Invent2 = 0;
            }
            this.searchData.CId = this.submitData.EntpCusId;
            this.searchData.SId = this.submitData.WarehouseId;
            if (this.SelectedData && this.SelectedData.length > 0) {
                this.searchData.SelectedData = this.SelectedData;
            }

            if (this.autoSeriesModel) {
                if (this.isUseAS) {
                    if (this.autoSeriesModel.AutoSeriesId) this.searchData.AutoSeriseId = this.autoSeriesModel.AutoSeriesId;
                    else this.searchData.AutoSerise = this.autoSeriesModel.ModelName;
                } else this.searchData.AutoSeriseId = '';
            }

            if (this.searchData.page == 1) {
                this.searchParams = {
                    ...this.searchData
                };
            } else {
                this.searchParams.page = this.searchData.page;
            }
            this.searchLoading = true;
            this.stopFresh = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpUnionGoods/GetUnionGoodsListForAgentOrder',
                    data: this.searchParams,
                    hideLoading: true
                })
                .then(res => {
                    this.searchLoading = false;
                    let data = res.data;
                    this.tableDataLength = res.count;
                    if (!data) {
                        if (this.searchData.page == 1) this.tableData = [];
                        return;
                    }
                    for (let i = 0; i < data.length; i++) {
                        data[i].LoadAfterData = true;
                    }
                    let list = [...this.tableData, ...data];
                    // const maps = new Map();
                    // list = list.filter(m => !maps.has(m.EntpTempGoodsId) && maps.set(m.EntpTempGoodsId, 1));
                    // //因为接口的原因，返回前后两页数据有重复，所以在这里做去重
                    this.tableData = list;

                    if (this.dataList.length > 0) {
                        this.tableData.forEach(goods => {
                            let idx = this.dataList.findIndex(f => f.EntpTempGoodsId == goods.EntpTempGoodsId);
                            if (idx > -1) {
                                goods.IsSelected = true;
                            }
                        });
                    }
                    this.stopFresh = data.length < this.searchData.limit;

                    this.getOtherData(data);
                })
                .catch(e => {
                    this.searchLoading = false;
                });
        },
                async getOtherData(data) {
            let that = this;
            if (data && data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                    that.loopGetData(data[i]);
                    await that.$util.sleep(100);
                }
                //使用表格方法更新数据，因为浏览器的兼容性，某些浏览器数据更新了但是页面线上还没有边，需要点击其它地方或滚动条滚动一下才触发变化，比如留余数一列
                this.$refs.multipleTable.updateData();
            }
        }, 
        loopGetData(goods) {
            let that = this;
            let url = '/api/EntpUnionGoods/GetAfterUnionGoodsListForAgentOrder';
            that.$util
                .axiosGet({
                    url: url,
                    data: {
                        GoodsId: goods.EntpTempGoodsId,
                        MyGoodsId:goods.MyGoodsId,
                        SortProp: that.searchData.SortProp,
                        PriceLevelId: goods.PriceLevelId,
                        UnionGoodsId: goods.UnionGoodsId,
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        return;
                    }

                    let tableGoods=that.tableData.find(e => e.EntpTempGoodsId ==goods.EntpTempGoodsId);
                    if(tableGoods){
                        if(!(that.searchData.SortProp == "Price" || that.searchData.SortProp == "MyInventory"
                        || that.searchData.SortProp == "MyInventory")){

                            tableGoods.MyInventory = data.MyInventory;
                            tableGoods.CostPrice = data.CostPrice;
                            tableGoods.Price = data.Price;
                            tableGoods.MarketPrice = data.MarketPrice;
                            
                            if(data.UnionPrice!=-1)
                                tableGoods.UnionPrice = data.UnionPrice;
                        }
                        tableGoods.UnionWaitOut = data.UnionWaitOut;
                        tableGoods.UnionWaitIn = data.UnionWaitIn;
                        tableGoods.OrderWaitOutQuantity = data.OrderWaitOutQuantity;      
                        tableGoods.POrderWaitInQuantity = data.POrderWaitInQuantity;     
                        tableGoods.LoadAfterData = false;
                    }
                })
                .catch(() => {});
        },
        showTableSetDialog() {
            this.tableSetsVisible = true;
        },
        onDateTimeSelect(val) {
            if (val != null) {
                this.searchData.InStartDate = val[0];
                this.searchData.InEndDate = val[1];
            } else {
                this.searchData.InStartDate = '';
                this.searchData.InEndDate = '';
            }
        },
        resetSearch() {
            this.searchData = {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                APCode: '',
                GoodCode: '',
                GoodName: '',
                GoodDesc: '',
                AutoSerise: '',
                Brand: '',
                BrandName: [],
                Size: '',
                Cate: [],
                page: 1,
                limit: 20,
                CId: '',
                SId: '',
                SortProp: '',
                SortType: '',
                JointSearch: '',
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                Origin: '',
                SearchType: 2,
                AutoSeriseId: ''
            };
            this.datetime = [];
            this.isSearch = false;
        },
        handleSearch() {
            let that = this;
            that.searchData.page = 1;
            that.dataindex = -1;
            that.tableData = [];
            that.isSearch = true;
            that.scrollTop = 0;

            if (!that.searchLoading) {
                that.getAPTableData();
            }
            if (that.searchVisible) {
                that.searchVisible = false;
                that.isStartSearch = false;
            }
        },
        getGoodsBrand() {
            if (this.brandList.length > 0) return;
            this.loading = true;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getGoodsType() {
            if (this.typeList.length > 0) return;
            this.loading = true;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        sourceVisibleChange(event){
            let that = this;
            if (event) {
                that.$util.getSalesOrderSources().then(data => {
                    that.cusSourcesList = data;
                });
            }
        },
        sourceChange(val){
            let that = this;
            if (val) {
                for (let i = 0; i < that.cusSourcesList.length; i++) {
                    if (val == that.cusSourcesList[i].Value) {
                        that.submitData.CusSourcesName = that.cusSourcesList[i].Text;
                        break;
                    }
                }
            } else {
                that.submitData.CusSourcesName = '';
            }
        },        
        tableRowClassName({ row, rowIndex }) {
            //把每一行的索引放进row
            row.index = rowIndex;
        },
        rowClick(row, column, event) {
            this.dataindex = row.index;
            this.currentRow = row;
            this.getInvenDatas(row);
        },
        // 列表双击打开弹框
        dblChooseAps(e) {
            let that = this;
            //先获取一些数据
            if ([e][0]) {
                that.rowFormLoading = true;
                that.rowVisible = true;
                that.isStartConfirm = true;
                if(e.MyGoodsId){
                    that.$util.getGoodsDataForConfirm_V3(e.MyGoodsId, '', that.submitData.EntpCusId, '0').then(data => {
                        if (data) {
                            that.rowForm = {
                                ...[e][0],
                                _price: data.LatestPrice,
                                _biilPrice: data.LatestPrice,
                                _count: 1,
                                _referencePrice: data.ReferencePrice ? data.ReferencePrice : e.MarketPrice
                            };
                        }
                        that.rowFormLoading = false;
                    });                   
                }else{
                        that.rowForm = {
                            ...[e][0],
                            _price: 0,
                            _biilPrice:0,
                            _count: 1,
                            _referencePrice: 0
                        };   
                        that.rowFormLoading = false;                
                }
            }
        },
        rowConfirm() {
            let that = this;
            let item = that.rowForm;
            let sIdx = that.tableData.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId);
            if (sIdx > -1) {
                that.tableData[sIdx].IsSelected = true;
            }
            let fIdx = that.dataList.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId);
            if (fIdx > -1) {
                if (!that.dataList[fIdx].IsDelivery) that.dataList[fIdx].OrderCount = item._count;
                that.dataList[fIdx].Price = item._price;
                that.dataList[fIdx].BillingPrice = item._biilPrice;
            } else {
                let newGoods = {};
                newGoods = {
                    EntpTempGoodsId: item.EntpTempGoodsId,
                    MyGoodsId: item.MyGoodsId,
                    APCode: item.APCode,
                    GoodName: item.GoodName,
                    GoodNameItem: item.GoodName,
                    AutoSerise: item.AutoSerise,
                    AutoSeriseItem: item.AutoSerise,
                    OrderCount: item._count,
                    Count: item.Count,
                    Price: item._price,
                    Unit: item.Unit,
                    Remark: '',
                    CodeRepeat: false,
                    MyInventory: item.MyInventory,
                    StorageInventory: item.StorageInventory,
                    WarehousedCount: 0,
                    OrderWaitOutQuantity: item.OrderWaitOutQuantity,
                    POrderWaitInQuantity: item.POrderWaitInQuantity,
                    State: 0,
                    canEdit: true,
                    IntenCount: item.IntenCount,
                    CostPrice: item.UnionPrice,
                    BillingPrice: item._biilPrice,
                    Origin: item.Origin,
                    Size: item.Size
                };
                that.dataList.push(newGoods);
            }
            that.priceChange();
            that.rowVisible = false;
            that.isStartConfirm = false;
        },
        rowClose() {
            this.rowVisible = false;
            this.isStartConfirm = false;
            this.rowForm = {};
        },
        showIntentDatas(id) {
            if (id) {
                if (this.inqHistoryVisible) {
                    this.$refs.APInquiryHistory.updateTableData(id);
                } else {
                    this.hisGoodsId = id;
                    this.inqHistoryVisible = true;
                }
            }
        },
        showNeedInData(item) {
            if (item.MyGoodsId && !this.needInDataVisible) {
                this.EntpTempGoodsId = item.MyGoodsId;
                this.NeedITitle = '【配件待入数据】配件编码：' + item.APCode + ' —— 配件名称：' + item.GoodName;
                this.needInDataVisible = true;
            } else if (item.MyGoodsId && this.needInDataVisible) {
                this.$refs.APNeedInDatas.updateTableData(item.MyGoodsId);
            }
        },
        showNeedOutData(item) {
            if (item.MyGoodsId && !this.needOutDataVisible) {
                this.EntpTempGoodsId = item.MyGoodsId;
                this.NeedOTitle = '【配件待出数据】配件编码：' + item.APCode + ' —— 配件名称：' + item.GoodName;
                this.needOutDataVisible = true;
            } else if (item.MyGoodsId && this.needOutDataVisible) {
                this.$refs.APNeedOutDatas.updateTableData(item.MyGoodsId);
            }
        },
        goback() {
            this.$router.push('/entpUnion/unionOrdersManage/myAgentOrders');
        },
        closeJointDialog() {
            this.jointSetVisible = false;
        },
        jointSets() {
            this.jointSetVisible = true;
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order ? event.order : '';
            if (this.searchData.SortType == '') this.searchData.SortProp = '';
            this.searchData.page = 1;
            this.dataindex = -1;
            this.tableData = [];
            this.scrollTop = 0;
            this.scrollLeft = 0;
            this.getAPTableData();
        },
        chooseAllAPsHandle() {
            let that = this;
            that.$confirm('是否将查询结果全部加入到联盟订单商品明细中？', '', {
                type: 'warning',
                distinguishCancelAndClose: true
            })
                .then(() => {
                    this.searchApParams = {
                        ...this.searchData,
                        limit: this.searchApParams._limit,
                        _visible: true,
                        _percentage: 0,
                        _limit: this.searchApParams._limit,
                        _totalCount: this.tableDataLength
                    };
                    this.loopSearch();
                })
                .catch(() => {});
        },
        // 开始循环
        async loopSearch() {
            const { data } = await this.$util.axiosPost({
                url: '/api/EntpUnionGoods/GetUnionGoodsListForAgentOrder_ForFull',
                data: this.searchApParams,
                hideLoading: true
            });
            this.searchApParams._percentage = parseInt(((this.searchApParams.page * this.searchApParams.limit) / this.searchApParams._totalCount) * 100);

            this.searchApParams.page += 1;
            let _stop = !data || data.length < this.searchApParams._limit;
            this.addToList(data);
            if (_stop) {
                this.searchApParams._percentage = 100;
                this.searchApParams._visible = false;
            } else {
                this.loopSearch();
            }
        },
        addToList(items) {
            let that = this;
            let itemList = [...items];
            let newGoodsList = [];
            for (let i = 0; i < itemList.length; i++) {
                let item = itemList[i];
                let isExist = false;
                that.dataList.forEach((e, index) => {
                    if (item.EntpTempGoodsId == e.EntpTempGoodsId) {
                        isExist = true;
                        e.StorageInventory = item.StorageInventory;
                    }
                });
                if (!isExist) {
                    let newGoods = {
                        Price: item.Price,
                        EntpTempGoodsId: item.EntpTempGoodsId,
                        MyGoodsId: item.MyGoodsId,
                        APCode: item.APCode,
                        GoodName: item.GoodName,
                        GoodNameItem: item.GoodName,
                        AutoSerise: item.AutoSerise,
                        AutoSeriseItem: item.AutoSerise,
                        Count: item.Count,
                        OrderCount: this.initNumber,
                        Unit: item.Unit,
                        Origin: item.Origin,
                        Remark: '',
                        CodeRepeat: false,
                        MyInventory: item.MyInventory,
                        WarehousedCount: 0,
                        State: 0,
                        canEdit: true,
                        IntenCount: item.IntenCount,
                        CostPrice: item.UnionPrice,
                        BillingPrice: item.Price == 0 ? '' : item.Price
                    };
                    if (!isNaN(item._count)) {
                        newGoods.OrderCount = item._count;
                    }
                    if (!isNaN(item._price)) {
                        newGoods.Price = item._price;
                    }
                    newGoodsList.push(newGoods);
                }
            }
            //判断最后一条数据是否空值，是的话移到最后，noClose 表示不关闭弹框
            if (that.dataList.length == 0) {
                that.dataList = that.dataList.concat(newGoodsList);
            } else {
                let lastItem = that.dataList[that.dataList.length - 1];
                if (!lastItem.APCode && !lastItem.GoodName) {
                    that.dataList.splice(that.dataList.length - 1, 1);
                    that.dataList = that.dataList.concat(newGoodsList);
                    that.dataList.push(lastItem);
                } else {
                    that.dataList = that.dataList.concat(newGoodsList);
                }
            }
            that.priceChange();
        },
        searchGoodName(key, cb) {
            this.$util.searchUnionPartAttr(key, 1, 1, 10).then(data => {
                let arr = [];
                if (data) {
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.goodNameOptions = arr;
                if (cb) {
                    cb(this.goodNameOptions);
                }
            });
        },
        searchAutoSerise(key, cb) {
            this.$util.searchUnionPartAttr(key, 2, 1, 10).then(data => {
                let arr = [];
                if (data) {
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.autoSeriseOptions = arr;
                if (cb) {
                    cb(this.autoSeriseOptions);
                }
            });
        },
        stopSearch() {
            this.canSearch = false;
        },
        // 客户改变
        customerChange(value) {
            let that = this;
            if (!value) {
                that.submitData.EntpCusName = '';
                that.submitData.PhoneNum = '';
                that.addressList = [];
                that.submitData.FullAddress = '';
            } else {
                //获取客户的名称、手机号、地址等数据
                let currCust = that.customerList.find(e => e.EntpCusId == value);
                if (currCust) {
                    that.submitData.EntpCusName = currCust.EntpCusName;
                    that.submitData.PhoneNum = currCust.CallNum;
                    that.addressList = [];
                    //这里要处理多个地址问题
                    if (currCust.FullAddress) {
                        if (currCust.FullAddress.indexOf('{$}') != -1) {
                            let addressArray = currCust.FullAddress.split('{$}');
                            addressArray.forEach((e, i) => {
                                that.addressList.push({
                                    value: e
                                });
                            });
                            that.submitData.FullAddress = addressArray[0];
                        } else {
                            that.submitData.FullAddress = currCust.FullAddress;
                        }
                    }
                }
                //查询对客户最新的商品销售价格
                if (that.dataList) {
                    let ids = [];
                    that.dataList.forEach((e, i) => {
                        if (e.MyGoodsId) ids.push(e.MyGoodsId);
                    });
                    if (ids.length > 0) {
                        that.$util
                            .axiosPost({
                                url: '/api/EntpSaleOrder/GetGoodsLatestPriceByCId',
                                data: {
                                    cId: value,
                                    ids: ids
                                }
                            })
                            .then(res => {
                                let data = res.data;
                                that.dataList.forEach((e, i) => {
                                    // 此时，商品已经填写对应的销售价、开单价的时，再选中客户，商品的销售价、开单价不变 edit 2020/3/22
                                    if (e.MarketPrice == 0 || e.MarketPrice == '0' || !(e.MarketPrice == null || e.MarketPrice == '')) return;
                                    let getGoods = data.find(d => d.GoodsId == e.MyGoodsId);
                                    if (getGoods) {
                                        // e.HidePrice=getGoods.MarketPrice;
                                        //替换销售价
                                        e.MarketPrice = getGoods.Price;
                                    }
                                });
                            })
                            .catch(() => {});
                    }
                }
            }
            this.getDefaultData();
        },
        //当客户下拉框出现时触发
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.customerList.length <= 1) that.searchCustomer('');
            }
        },
        // 搜索顾客
        searchCustomer(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.customerList = [];
            }
            if (this.cusForm.stopLoad) return;
            this.loading = true;
            this.$util
                .searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit)
                .then(data => {
                    this.cusForm.stopLoad = data && data.length < this.cusForm.Limit;
                    if (data) this.customerList = [...this.customerList, ...data];
                    //修改客户时要更新页面上展现的名称
                    if (this.customerList.length > 0) {
                        let currCust = this.customerList.find(e => e.EntpCusId == this.submitData.EntpCusId);
                        if (currCust) {
                            this.submitData.EntpCusName = currCust.EntpCusName;
                            this.submitData.PhoneNum = currCust.CallNum;
                            this.addressList = [];
                            //这里要处理多个地址问题
                            if (currCust.FullAddress) {
                                if (currCust.FullAddress.indexOf('{$}') != -1) {
                                    let addressArray = currCust.FullAddress.split('{$}');
                                    addressArray.forEach((e, i) => {
                                        this.addressList.push({
                                            value: e
                                        });
                                    });
                                    this.submitData.FullAddress = addressArray[0];
                                } else {
                                    this.submitData.FullAddress = currCust.FullAddress;
                                }
                            }
                        }
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustomer();
        },
        getInvenDatas(row) {
            let that = this;
            if (!row || !that.isStoDataShow) return;
            that.$util
                .axiosGet({
                    url: '/api/EntpUnionGoods/GetGoodsStorageInvens',
                    data: {
                        GoodsId: row.EntpTempGoodsId,
                        UnionId: this.submitData.UnionId
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        return;
                    }
                    that.isShowSummary = true;
                    that.summaryList = data;
                })
                .catch(() => {});
        },
        closeViewer() {
            this.showViewer = false;
            this.$message.closeAll();
        },
        async getGoodsImages() {
            if (this.isGoodsImgShow) {
                if (this.currentRow) {
                    if (!this.srcList || this.srcList.length == 0) {
                        const { data } = await this.$util.axiosGet({
                            url: '/api/EntpGoods/GetGoodsImages',
                            data: { goodsId: this.currentRow.EntpTempGoodsId }
                        });
                        if (data) {
                            this.srcList = data;
                        }
                    }
                    this.showViewer = true;
                    this.$message({
                        message: this.currentRow.APCode,
                        center: true,
                        duration: 0,
                        customClass: 'apcode_msgCls'
                    });
                }
            }
        },
        vinSearch() {
            this.vinSearchVisible = true;
        },
        closeVinSearch() {
            let that = this;
            that.vinSearchVisible = false;
            that.autoSeriesModel = this.$util.getLocalStorage('union_vin_createParams');
            that.matchCount = this.$util.getLocalStorage('union_vin_matchcount');
            if (that.autoSeriesModel) {
                that.isUseAS = true;
                that.$util.clearLocalStorage('union_vin_createParams');
                that.$util.clearLocalStorage('union_vin_matchcount');
                that.handleSearch();
            }
        },
        closeAutoSeries() {
            this.autoSeriesModel = null;
            this.searchData.AutoSeriseId = '';
        },
        //关联商品
        connectGoods(){
            let that = this;
            let item = that.rowForm;
            if(item){
                that.rowFormLoading = true;
                that.$util
                    .axiosGet({
                        url: `/api/EntpUnionGoods/CheckHaveSameCode?APCode=${item.APCode}&UGoodsId=${item.EntpTempGoodsId}&UnionId=${that.submitData.UnionId}`,
                        hideLoading:true
                    })
                    .then(res => {
                        let data = res.data;
                        if(JSON.parse(data)){
                            //存在相同编码
                            that.$confirm('检测到您有相同的编码，是否继续提取，创建新的配件商品', '提示', {
                                confirmButtonText: '去提取',
                                cancelButtonText: '去关联',
                                type: 'warning',
                                center: false,
                                closeOnPressEscape:false,//按下 ESC 键关闭弹窗
                                closeOnClickModal:false,//点击遮罩关闭弹窗
                                distinguishCancelAndClose:true,//区分取消与关闭                                
                            })
                            .then(() => {
                                that.goodsId = item.EntpTempGoodsId;
                                that.tranAPVisible = true;
                            })
                            .catch((action) => {
                                if(action=='cancel')
                                {   
                                    that.goodsId = item.EntpTempGoodsId;
                                    that.searchAPVisible = true;
                                }
                            });                            
                        }else{
                                that.goodsId = item.EntpTempGoodsId;
                                that.tranAPVisible = true;                            
                        }
                        that.rowFormLoading = false;
                    })
                    .catch(() => {that.rowFormLoading = false;});
            }else{
                this.$util.warningMsg('商品信息异常');
                return;
            }            
        },
        //关闭提取弹框
        closeTranAPDialog(data) {
            let that=this;
            if(data){
                that.rowForm.MyGoodsId=data.GoodsId;
                let sIdx = that.tableData.findIndex(f => f.EntpTempGoodsId === that.rowForm.EntpTempGoodsId);
                if (sIdx > -1) {
                    that.tableData[sIdx].MyGoodsId = data.GoodsId;
                    that.tableData[sIdx].MyInventory = data.Inventory;
                    that.tableData[sIdx].CreateTime = data.CreateTime;
                    that.tableData[sIdx].CostPrice = data.CostPrice;
                    that.tableData[sIdx].Price = data.Price;
                    that.tableData[sIdx].MarketPrice = data.MarketPrice;
                }                
                that.tranAPVisible = false;
                that.rowFormLoading = true;
                that.$util.getGoodsDataForConfirm_V3(data.GoodsId, '', that.submitData.EntpCusId, '0').then(resp => {
                    if (resp) {
                        that.rowForm._price=resp.LatestPrice;
                        that.rowForm._biilPrice=resp.LatestPrice;
                        that.rowForm._referencePrice=resp.ReferencePrice ? resp.ReferencePrice : data.MarketPrice;
                    }
                    that.rowFormLoading = false;
                });                 
            }else
                that.tranAPVisible = false;
        },  
        //关闭关联弹窗
        CloseReleDialog(data) {
            let that=this;
            if(data){
                that.rowForm.MyGoodsId=data.GoodsId;
                let sIdx = that.tableData.findIndex(f => f.EntpTempGoodsId === that.rowForm.EntpTempGoodsId);
                if (sIdx > -1) {
                    that.tableData[sIdx].MyGoodsId = data.GoodsId;
                    that.tableData[sIdx].MyInventory = data.Inventory;
                    that.tableData[sIdx].CreateTime = data.CreateTime;
                    that.tableData[sIdx].CostPrice = data.CostPrice;
                    that.tableData[sIdx].Price = data.Price;
                    that.tableData[sIdx].MarketPrice = data.MarketPrice;                                        
                }                
                that.searchAPVisible = false;
                that.rowFormLoading = true;
                that.$util.getGoodsDataForConfirm_V3(data.GoodsId, '', that.submitData.EntpCusId, '0').then(resp => {
                    if (resp) {
                        that.rowForm._price=resp.LatestPrice;
                        that.rowForm._biilPrice=resp.LatestPrice;
                        that.rowForm._referencePrice=resp.ReferencePrice ? resp.ReferencePrice : data.MarketPrice;
                    }
                    that.rowFormLoading = false;
                });                   
            }else
                that.searchAPVisible = false;
        },           
    }
};
</script>
<style lang="less" scoped>
.invens-summary {
    display: flex;
    flex-direction: row;
    height: 40px;
    line-height: 30px;
    padding: 0 20px;
    font-size: 14px;
    margin-left: -1px;
    border: 1px solid rgb(226, 226, 226);
    align-items: center;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;

    .title {
        font-size: 16px;
        font-weight: 600;
    }
    .summary-item {
        display: flex;
        flex-direction: row;

        .sname {
            font-size: 18px;
        }

        .scount {
            font-size: 20px;
            font-weight: 700px;
            color: #ea7060;
            margin-right: 20px;
        }
    }
}
.saleorder-v3 {
    padding: 10px 20px 0px 20px;
}

.tooltip-div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
}

.s-btn,
.s-btn:focus,
.s-btn.is-active,
.s-btn.is-disabled:active,
.s-btn:active {
    padding: 3px;
    font-size: 15px;
    color: #fff;
    background: #ea7060;
    background-color: #ea7060;
    margin-right: 2px;
}

.s-btn.is-disabled:hover,
.s-btn:hover,
.s-btn.is-disabled {
    padding: 4px 4px;
    background: #f3bb53;
    background-color: #f3bb53;
    color: #fff;
}

.b-btn,
.b-btn:focus,
.b-btn.is-active,
.b-btn.is-disabled:active,
.b-btn:active {
    padding: 3px;
    font-size: 15px;
    color: #fff;
    background: #bac225;
    background-color: #bac225;
    margin-right: 2px;
}

.b-btn.is-disabled:hover,
.b-btn:hover,
.b-btn.is-disabled {
    padding: 4px 4px;
    background: #f3bb53;
    background-color: #f3bb53;
    color: #fff;
}

.payment-tip {
    position: absolute;
    left: 0;
    bottom: -18px;
    line-height: 1;
    font-size: 12px;
    color: @font4Color;
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 32px;
    line-height: 32px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}

.edit-ctn {
    .div-table-cell {
        padding: 0 5px;
    }
}

.option-content {
    display: flex;
    line-height: 30px;

    .project-Name {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 12px;
    }

    .project-iven {
        width: 50px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

.btn-ctn {
    padding: 30px 0;
    margin-right: 110px;
    text-align: right;
}

.add-btn {
    position: absolute;
    right: 2%;
    bottom: 0;
}

.less-btn {
    position: absolute;
    right: -40px;
    top: 2px;
    z-index: 2;
}

.table-main {
    position: relative;
}

.image-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border: 1px dashed @border3Color;
}

.table-title {
    line-height: 36px;
    text-align: center;
    font-weight: bold;
}

.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    flex-grow: 1;
}

.table-item {
    height: 50px;
    position: relative;
}

.div-table-row {
    overflow: inherit;
    margin: -1px -1px -1px 0px;
}

.info-icon {
    vertical-align: top;
    margin-top: 2px;
    margin-right: 5px;
}

.special-border {
    height: 100%;
    border-radius: 3px;
    border: 1px solid #ffcc00;
}

.head-view {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .color-red {
        margin-right: 4px;
    }

    .sort-view {
        display: flex;
        flex-direction: column;

        i {
            line-height: 8px;
            cursor: pointer;
        }

        .active {
            color: #409eff;
        }
    }
}

.saveProgress {
    position: absolute;
    top: 38%;
    left: 45%;
    z-index: 99999;
}

.customer-view {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .grid-content {
        flex: 1;
    }

    .customer-checked {
        margin-left: 24px;
    }
}

.img-e-op {
    height: 32px;
    width: 32px;

    img {
        height: 28px;
        width: 28px;
        margin-bottom: 2px;
    }
}

.section-magin {
    margin-bottom: 5px;
}

.discount-zone {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    .el-input-number {
        width: 110px;

        .el-input__inner {
            height: 32px;
        }
    }

    .el-select {
        margin-right: 12px;

        .el-input__inner {
            width: 110px;
            height: 32px;
            color: red;
        }

        .el-input__suffix {
            top: 4px;
        }

        .is-focus {
            .el-input__suffix {
                top: -4px;
            }
        }
    }
}

#search-dc-dialog,
#comfirm-ap-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .search-item-dialog {
        width: 340px;
        height: auto;

        .dialog-footer {
            text-align: right;
        }

        .el-form-item {
            margin-bottom: 0;
        }
    }

    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}

.search-set-btn {
    margin-top: 4px;
    height: 24px;
    width: 25px;
    line-height: 24px;
    padding: 0;
    margin-right: 5px;
}

#ap-image-dialog {
    position: absolute;
    top: auto;
    left: 0;
    right: auto;
    bottom: 400px;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .image-item-dialog {
        width: 120px;
        height: 120px;
    }

    .el-dialog__body {
        padding: 0 !important;
        overflow: auto;
    }
}

.image-item-dialog {
    width: 120px;
    height: 120px;
}
</style>

<style lang="less">
.order-infoes {
    border: 1px solid @border3Color;
    padding-top: 10px;
    margin-bottom: 10px;

    .grid-content {
        border-radius: 4px;
        min-height: 32px;
    }
    .el-form-item {
        margin-bottom: 0px;
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__label {
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__content {
        line-height: 32px !important;
        height: 32px;
        top: -1px;
    }
}

.pop-cls {
    font-size: 18px;
    padding: 10px 12px;
    color: #fff;
    background-color: #303133;

    .popper__arrow {
        color: #303133;
    }
}

#search-dialog {
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .el-dialog__body {
        overflow: auto;
    }
}

#search-dialog::-webkit-scrollbar {
    display: none;
}

.check-code-class {
    .el-input__inner {
        border: 1px solid #f56c6c;
    }
}

.loseMoneyWarning {
    .el-input__inner {
        border: 1px solid #e6a23c;
    }
}

.el-col {
    border-radius: 4px;
}

.bg-purple-dark {
    background: #99a9bf;
}

.bg-purple {
    background: #d3dce6;
}

.bg-purple-light {
    background: #e5e9f2;
}

.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}

.el-row {
    margin-bottom: 10px !important;

    &:last-child {
        margin-bottom: 10px !important;
    }
}

.search-in-order {
    margin-bottom: 5px;

    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }

        .elx-table--header-wrapper {
            .elx-header--row {
                .elx-header--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }

        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }

                td {
                    height: 26px;
                    line-height: 26px;
                }
            }

            .elx-cell {
                height: 26px;
            }
        }

        .elx-table--footer-wrapper {
            margin-top: 0 !important;
        }
    }
}

.sales-order-edit {
    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }

        .elx-table--header-wrapper {
            .elx-header--row {
                .elx-header--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }

        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }

                .div-padding-12 {
                    padding: 4px 8px 0;
                }

                .div-margin-op {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }

                .operate {
                    padding: 0 12px;
                }

                td {
                    height: 26px;
                }
            }

            .elx-cell {
                padding: 0;
                height: 32px;
            }

            .el-button--small {
                padding: 5px 15px;
                margin: 3px 9px 0 0;
            }
        }

        .elx-table--footer-wrapper {
            margin-top: 0 !important;
        }

        .elx-table--body-wrapper {
            padding-bottom: 180px !important;
        }

        // .elx-table--body tr.row--current > td {
        //   background: rgb(206, 206, 206) !important;
        // }
    }

    .sales-input-cell {
        .el-input-number {
            width: 100%;
        }

        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }

        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }

    .salecounts-input-cell {
        .el-input-number {
            width: 100%;
        }

        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }

        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }

    .unit-input-cell {
        .el-input {
            .el-input__inner {
                padding-right: 20px;
            }
        }
    }

    .sales-apcode {
        .el-tag {
            height: 24px;
            line-height: 22px;
            margin-left: 8px;
        }

        .sp-i {
            height: 24px;
            margin-left: -6px;
            margin-right: 2px;
        }
        .el-icon-info {
            color: #87a7d6;
            font-size: 18px;
            vertical-align: top;
            cursor: pointer;
            margin-top: 2px;
        }
    }
}
</style>
